/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import {
  GrpcMessage,
  RecursivePartial,
  ToProtobufJSONOptions
} from '@ngx-grpc/common';
import { BinaryReader, BinaryWriter, ByteSource } from 'google-protobuf';
import * as googleType000 from '../../../../external/mercury/v1/shared/google/type/decimal.pb';
import * as googleProtobuf001 from '@ngx-grpc/well-known-types';
import * as booking_platformV1Shared002 from '../../../../external/mercury/v1/shared/guest-type.pb';
import * as booking_platformV1Shared003 from '../../../../external/mercury/v1/shared/prices-by-start-time.pb';
import * as booking_platformV1AttractionCommon004 from '../../../../external/mercury/v1/attraction/common/product-detail.pb';
import * as booking_platformV1Shared005 from '../../../../external/mercury/v1/shared/guest-configuration.pb';
import * as booking_platformV1Shared006 from '../../../../external/mercury/v1/shared/product-availability-range.pb';
import * as booking_platformV1AttractionCommon007 from '../../../../external/mercury/v1/attraction/common/attraction-product-option.pb';
export enum Category {
  ATTRACTION = 0,
  ATTRACTION_LOCATION = 1
}
/**
 * Message implementation for booking_platform.v1.attraction.AutoCompleteSearchRequest
 */
export class AutoCompleteSearchRequest implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AutoCompleteSearchRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AutoCompleteSearchRequest();
    AutoCompleteSearchRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AutoCompleteSearchRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.languageCode = _instance.languageCode || '';
    _instance.categories = _instance.categories || [];
    _instance.searchString = _instance.searchString || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AutoCompleteSearchRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.languageCode = _reader.readString();
          break;
        case 5:
          (_instance.categories = _instance.categories || []).push(
            ...(_reader.readPackedEnum() || [])
          );
          break;
        case 6:
          _instance.searchString = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AutoCompleteSearchRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AutoCompleteSearchRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.languageCode) {
      _writer.writeString(4, _instance.languageCode);
    }
    if (_instance.categories && _instance.categories.length) {
      _writer.writePackedEnum(5, _instance.categories);
    }
    if (_instance.searchString) {
      _writer.writeString(6, _instance.searchString);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _languageCode: string;
  private _categories: Category[];
  private _searchString: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AutoCompleteSearchRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AutoCompleteSearchRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.languageCode = _value.languageCode;
    this.categories = (_value.categories || []).slice();
    this.searchString = _value.searchString;
    AutoCompleteSearchRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get categories(): Category[] {
    return this._categories;
  }
  set categories(value: Category[]) {
    this._categories = value;
  }
  get searchString(): string {
    return this._searchString;
  }
  set searchString(value: string) {
    this._searchString = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AutoCompleteSearchRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AutoCompleteSearchRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      categories: (this.categories || []).slice(),
      searchString: this.searchString
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AutoCompleteSearchRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      categories: (this.categories || []).map(v => Category[v]),
      searchString: this.searchString
    };
  }
}
export module AutoCompleteSearchRequest {
  /**
   * Standard JavaScript object representation for AutoCompleteSearchRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    categories: Category[];
    searchString: string;
  }

  /**
   * Protobuf JSON representation for AutoCompleteSearchRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    categories: string[];
    searchString: string;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AutoCompleteSearchResponse
 */
export class AutoCompleteSearchResponse implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AutoCompleteSearchResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AutoCompleteSearchResponse();
    AutoCompleteSearchResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AutoCompleteSearchResponse) {
    _instance.categories = _instance.categories || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AutoCompleteSearchResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AutoCompleteResultsByCategories();
          _reader.readMessage(
            messageInitializer1,
            AutoCompleteResultsByCategories.deserializeBinaryFromReader
          );
          (_instance.categories = _instance.categories || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AutoCompleteSearchResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AutoCompleteSearchResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.categories && _instance.categories.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.categories as any,
        AutoCompleteResultsByCategories.serializeBinaryToWriter
      );
    }
  }

  private _categories?: AutoCompleteResultsByCategories[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AutoCompleteSearchResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AutoCompleteSearchResponse.AsObject>) {
    _value = _value || {};
    this.categories = (_value.categories || []).map(
      m => new AutoCompleteResultsByCategories(m)
    );
    AutoCompleteSearchResponse.refineValues(this);
  }
  get categories(): AutoCompleteResultsByCategories[] | undefined {
    return this._categories;
  }
  set categories(value: AutoCompleteResultsByCategories[] | undefined) {
    this._categories = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AutoCompleteSearchResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AutoCompleteSearchResponse.AsObject {
    return {
      categories: (this.categories || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AutoCompleteSearchResponse.AsProtobufJSON {
    return {
      categories: (this.categories || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AutoCompleteSearchResponse {
  /**
   * Standard JavaScript object representation for AutoCompleteSearchResponse
   */
  export interface AsObject {
    categories?: AutoCompleteResultsByCategories.AsObject[];
  }

  /**
   * Protobuf JSON representation for AutoCompleteSearchResponse
   */
  export interface AsProtobufJSON {
    categories: AutoCompleteResultsByCategories.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AutoCompleteResultsByCategories
 */
export class AutoCompleteResultsByCategories implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AutoCompleteResultsByCategories';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AutoCompleteResultsByCategories();
    AutoCompleteResultsByCategories.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AutoCompleteResultsByCategories) {
    _instance.category = _instance.category || 0;
    _instance.results = _instance.results || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AutoCompleteResultsByCategories,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.category = _reader.readEnum();
          break;
        case 2:
          const messageInitializer2 = new AutoCompleteResultItem();
          _reader.readMessage(
            messageInitializer2,
            AutoCompleteResultItem.deserializeBinaryFromReader
          );
          (_instance.results = _instance.results || []).push(
            messageInitializer2
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AutoCompleteResultsByCategories.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AutoCompleteResultsByCategories,
    _writer: BinaryWriter
  ) {
    if (_instance.category) {
      _writer.writeEnum(1, _instance.category);
    }
    if (_instance.results && _instance.results.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.results as any,
        AutoCompleteResultItem.serializeBinaryToWriter
      );
    }
  }

  private _category: Category;
  private _results?: AutoCompleteResultItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AutoCompleteResultsByCategories to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<AutoCompleteResultsByCategories.AsObject>
  ) {
    _value = _value || {};
    this.category = _value.category;
    this.results = (_value.results || []).map(
      m => new AutoCompleteResultItem(m)
    );
    AutoCompleteResultsByCategories.refineValues(this);
  }
  get category(): Category {
    return this._category;
  }
  set category(value: Category) {
    this._category = value;
  }
  get results(): AutoCompleteResultItem[] | undefined {
    return this._results;
  }
  set results(value: AutoCompleteResultItem[] | undefined) {
    this._results = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AutoCompleteResultsByCategories.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AutoCompleteResultsByCategories.AsObject {
    return {
      category: this.category,
      results: (this.results || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AutoCompleteResultsByCategories.AsProtobufJSON {
    return {
      category:
        Category[
          this.category === null || this.category === undefined
            ? 0
            : this.category
        ],
      results: (this.results || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AutoCompleteResultsByCategories {
  /**
   * Standard JavaScript object representation for AutoCompleteResultsByCategories
   */
  export interface AsObject {
    category: Category;
    results?: AutoCompleteResultItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for AutoCompleteResultsByCategories
   */
  export interface AsProtobufJSON {
    category: string;
    results: AutoCompleteResultItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AutoCompleteResultItem
 */
export class AutoCompleteResultItem implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AutoCompleteResultItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AutoCompleteResultItem();
    AutoCompleteResultItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AutoCompleteResultItem) {
    _instance.name = _instance.name || '';
    _instance.id = _instance.id || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AutoCompleteResultItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.name = _reader.readString();
          break;
        case 2:
          _instance.id = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    AutoCompleteResultItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AutoCompleteResultItem,
    _writer: BinaryWriter
  ) {
    if (_instance.name) {
      _writer.writeString(1, _instance.name);
    }
    if (_instance.id) {
      _writer.writeInt32(2, _instance.id);
    }
  }

  private _name: string;
  private _id: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AutoCompleteResultItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<AutoCompleteResultItem.AsObject>) {
    _value = _value || {};
    this.name = _value.name;
    this.id = _value.id;
    AutoCompleteResultItem.refineValues(this);
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AutoCompleteResultItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AutoCompleteResultItem.AsObject {
    return {
      name: this.name,
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AutoCompleteResultItem.AsProtobufJSON {
    return {
      name: this.name,
      id: this.id
    };
  }
}
export module AutoCompleteResultItem {
  /**
   * Standard JavaScript object representation for AutoCompleteResultItem
   */
  export interface AsObject {
    name: string;
    id: number;
  }

  /**
   * Protobuf JSON representation for AutoCompleteResultItem
   */
  export interface AsProtobufJSON {
    name: string;
    id: number;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.SearchRequest
 */
export class SearchRequest implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.SearchRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SearchRequest();
    SearchRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SearchRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.currencyCode = _instance.currencyCode || '';
    _instance.languageCode = _instance.languageCode || '';
    _instance.startDate = _instance.startDate || '';
    _instance.endDate = _instance.endDate || '';
    _instance.productIds = _instance.productIds || [];
    _instance.locationId = _instance.locationId || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SearchRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.currencyCode = _reader.readString();
          break;
        case 5:
          _instance.languageCode = _reader.readString();
          break;
        case 6:
          _instance.startDate = _reader.readString();
          break;
        case 7:
          _instance.endDate = _reader.readString();
          break;
        case 8:
          (_instance.productIds = _instance.productIds || []).push(
            _reader.readInt32()
          );
          break;
        case 9:
          _instance.locationId = new googleProtobuf001.Int32Value();
          _reader.readMessage(
            _instance.locationId,
            googleProtobuf001.Int32Value.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    SearchRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SearchRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.currencyCode) {
      _writer.writeString(4, _instance.currencyCode);
    }
    if (_instance.languageCode) {
      _writer.writeString(5, _instance.languageCode);
    }
    if (_instance.startDate) {
      _writer.writeString(6, _instance.startDate);
    }
    if (_instance.endDate) {
      _writer.writeString(7, _instance.endDate);
    }
    if (_instance.productIds && _instance.productIds.length) {
      _writer.writeRepeatedInt32(8, _instance.productIds);
    }
    if (_instance.locationId) {
      _writer.writeMessage(
        9,
        _instance.locationId as any,
        googleProtobuf001.Int32Value.serializeBinaryToWriter
      );
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _currencyCode: string;
  private _languageCode: string;
  private _startDate: string;
  private _endDate: string;
  private _productIds: number[];
  private _locationId?: googleProtobuf001.Int32Value;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SearchRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SearchRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.currencyCode = _value.currencyCode;
    this.languageCode = _value.languageCode;
    this.startDate = _value.startDate;
    this.endDate = _value.endDate;
    this.productIds = (_value.productIds || []).slice();
    this.locationId = _value.locationId
      ? new googleProtobuf001.Int32Value(_value.locationId)
      : undefined;
    SearchRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get currencyCode(): string {
    return this._currencyCode;
  }
  set currencyCode(value: string) {
    this._currencyCode = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get startDate(): string {
    return this._startDate;
  }
  set startDate(value: string) {
    this._startDate = value;
  }
  get endDate(): string {
    return this._endDate;
  }
  set endDate(value: string) {
    this._endDate = value;
  }
  get productIds(): number[] {
    return this._productIds;
  }
  set productIds(value: number[]) {
    this._productIds = value;
  }
  get locationId(): googleProtobuf001.Int32Value | undefined {
    return this._locationId;
  }
  set locationId(value: googleProtobuf001.Int32Value | undefined) {
    this._locationId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SearchRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SearchRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      currencyCode: this.currencyCode,
      languageCode: this.languageCode,
      startDate: this.startDate,
      endDate: this.endDate,
      productIds: (this.productIds || []).slice(),
      locationId: this.locationId ? this.locationId.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SearchRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      currencyCode: this.currencyCode,
      languageCode: this.languageCode,
      startDate: this.startDate,
      endDate: this.endDate,
      productIds: (this.productIds || []).slice(),
      locationId: this.locationId
        ? this.locationId.toProtobufJSON(options)
        : null
    };
  }
}
export module SearchRequest {
  /**
   * Standard JavaScript object representation for SearchRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    currencyCode: string;
    languageCode: string;
    startDate: string;
    endDate: string;
    productIds: number[];
    locationId?: googleProtobuf001.Int32Value.AsObject;
  }

  /**
   * Protobuf JSON representation for SearchRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    currencyCode: string;
    languageCode: string;
    startDate: string;
    endDate: string;
    productIds: number[];
    locationId: googleProtobuf001.Int32Value.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.SearchResponse
 */
export class SearchResponse implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.SearchResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SearchResponse();
    SearchResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SearchResponse) {
    _instance.results = _instance.results || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SearchResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new booking_platformV1AttractionCommon004.ProductDetail();
          _reader.readMessage(
            messageInitializer1,
            booking_platformV1AttractionCommon004.ProductDetail
              .deserializeBinaryFromReader
          );
          (_instance.results = _instance.results || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    SearchResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SearchResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.results && _instance.results.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.results as any,
        booking_platformV1AttractionCommon004.ProductDetail
          .serializeBinaryToWriter
      );
    }
  }

  private _results?: booking_platformV1AttractionCommon004.ProductDetail[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SearchResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<SearchResponse.AsObject>) {
    _value = _value || {};
    this.results = (_value.results || []).map(
      m => new booking_platformV1AttractionCommon004.ProductDetail(m)
    );
    SearchResponse.refineValues(this);
  }
  get results():
    | booking_platformV1AttractionCommon004.ProductDetail[]
    | undefined {
    return this._results;
  }
  set results(
    value: booking_platformV1AttractionCommon004.ProductDetail[] | undefined
  ) {
    this._results = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SearchResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SearchResponse.AsObject {
    return {
      results: (this.results || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SearchResponse.AsProtobufJSON {
    return {
      results: (this.results || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module SearchResponse {
  /**
   * Standard JavaScript object representation for SearchResponse
   */
  export interface AsObject {
    results?: booking_platformV1AttractionCommon004.ProductDetail.AsObject[];
  }

  /**
   * Protobuf JSON representation for SearchResponse
   */
  export interface AsProtobufJSON {
    results:
      | booking_platformV1AttractionCommon004.ProductDetail.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AvailabilityRequest
 */
export class AvailabilityRequest implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AvailabilityRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AvailabilityRequest();
    AvailabilityRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AvailabilityRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.currencyCode = _instance.currencyCode || '';
    _instance.languageCode = _instance.languageCode || '';
    _instance.travelDate = _instance.travelDate || '';
    _instance.productId = _instance.productId || 0;
    _instance.guests = _instance.guests || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AvailabilityRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.currencyCode = _reader.readString();
          break;
        case 5:
          _instance.languageCode = _reader.readString();
          break;
        case 6:
          _instance.travelDate = _reader.readString();
          break;
        case 7:
          _instance.productId = _reader.readInt32();
          break;
        case 8:
          const messageInitializer8 = new booking_platformV1Shared005.GuestConfiguration();
          _reader.readMessage(
            messageInitializer8,
            booking_platformV1Shared005.GuestConfiguration
              .deserializeBinaryFromReader
          );
          (_instance.guests = _instance.guests || []).push(messageInitializer8);
          break;
        default:
          _reader.skipField();
      }
    }

    AvailabilityRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AvailabilityRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.currencyCode) {
      _writer.writeString(4, _instance.currencyCode);
    }
    if (_instance.languageCode) {
      _writer.writeString(5, _instance.languageCode);
    }
    if (_instance.travelDate) {
      _writer.writeString(6, _instance.travelDate);
    }
    if (_instance.productId) {
      _writer.writeInt32(7, _instance.productId);
    }
    if (_instance.guests && _instance.guests.length) {
      _writer.writeRepeatedMessage(
        8,
        _instance.guests as any,
        booking_platformV1Shared005.GuestConfiguration.serializeBinaryToWriter
      );
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _currencyCode: string;
  private _languageCode: string;
  private _travelDate: string;
  private _productId: number;
  private _guests?: booking_platformV1Shared005.GuestConfiguration[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AvailabilityRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AvailabilityRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.currencyCode = _value.currencyCode;
    this.languageCode = _value.languageCode;
    this.travelDate = _value.travelDate;
    this.productId = _value.productId;
    this.guests = (_value.guests || []).map(
      m => new booking_platformV1Shared005.GuestConfiguration(m)
    );
    AvailabilityRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get currencyCode(): string {
    return this._currencyCode;
  }
  set currencyCode(value: string) {
    this._currencyCode = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get travelDate(): string {
    return this._travelDate;
  }
  set travelDate(value: string) {
    this._travelDate = value;
  }
  get productId(): number {
    return this._productId;
  }
  set productId(value: number) {
    this._productId = value;
  }
  get guests(): booking_platformV1Shared005.GuestConfiguration[] | undefined {
    return this._guests;
  }
  set guests(
    value: booking_platformV1Shared005.GuestConfiguration[] | undefined
  ) {
    this._guests = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AvailabilityRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AvailabilityRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      currencyCode: this.currencyCode,
      languageCode: this.languageCode,
      travelDate: this.travelDate,
      productId: this.productId,
      guests: (this.guests || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AvailabilityRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      currencyCode: this.currencyCode,
      languageCode: this.languageCode,
      travelDate: this.travelDate,
      productId: this.productId,
      guests: (this.guests || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AvailabilityRequest {
  /**
   * Standard JavaScript object representation for AvailabilityRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    currencyCode: string;
    languageCode: string;
    travelDate: string;
    productId: number;
    guests?: booking_platformV1Shared005.GuestConfiguration.AsObject[];
  }

  /**
   * Protobuf JSON representation for AvailabilityRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    currencyCode: string;
    languageCode: string;
    travelDate: string;
    productId: number;
    guests:
      | booking_platformV1Shared005.GuestConfiguration.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AvailabilityResponse
 */
export class AvailabilityResponse implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AvailabilityResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AvailabilityResponse();
    AvailabilityResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AvailabilityResponse) {
    _instance.productOptions = _instance.productOptions || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AvailabilityResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new booking_platformV1AttractionCommon007.AttractionProductOption();
          _reader.readMessage(
            messageInitializer1,
            booking_platformV1AttractionCommon007.AttractionProductOption
              .deserializeBinaryFromReader
          );
          (_instance.productOptions = _instance.productOptions || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AvailabilityResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AvailabilityResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.productOptions && _instance.productOptions.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.productOptions as any,
        booking_platformV1AttractionCommon007.AttractionProductOption
          .serializeBinaryToWriter
      );
    }
  }

  private _productOptions?: booking_platformV1AttractionCommon007.AttractionProductOption[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AvailabilityResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AvailabilityResponse.AsObject>) {
    _value = _value || {};
    this.productOptions = (_value.productOptions || []).map(
      m => new booking_platformV1AttractionCommon007.AttractionProductOption(m)
    );
    AvailabilityResponse.refineValues(this);
  }
  get productOptions():
    | booking_platformV1AttractionCommon007.AttractionProductOption[]
    | undefined {
    return this._productOptions;
  }
  set productOptions(
    value:
      | booking_platformV1AttractionCommon007.AttractionProductOption[]
      | undefined
  ) {
    this._productOptions = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AvailabilityResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AvailabilityResponse.AsObject {
    return {
      productOptions: (this.productOptions || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AvailabilityResponse.AsProtobufJSON {
    return {
      productOptions: (this.productOptions || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module AvailabilityResponse {
  /**
   * Standard JavaScript object representation for AvailabilityResponse
   */
  export interface AsObject {
    productOptions?: booking_platformV1AttractionCommon007.AttractionProductOption.AsObject[];
  }

  /**
   * Protobuf JSON representation for AvailabilityResponse
   */
  export interface AsProtobufJSON {
    productOptions:
      | booking_platformV1AttractionCommon007.AttractionProductOption.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AttractionDetailsRequest
 */
export class AttractionDetailsRequest implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AttractionDetailsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttractionDetailsRequest();
    AttractionDetailsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttractionDetailsRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.languageCode = _instance.languageCode || '';
    _instance.productId = _instance.productId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttractionDetailsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.languageCode = _reader.readString();
          break;
        case 5:
          _instance.productId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    AttractionDetailsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttractionDetailsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.languageCode) {
      _writer.writeString(4, _instance.languageCode);
    }
    if (_instance.productId) {
      _writer.writeInt32(5, _instance.productId);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _languageCode: string;
  private _productId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttractionDetailsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttractionDetailsRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.languageCode = _value.languageCode;
    this.productId = _value.productId;
    AttractionDetailsRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get productId(): number {
    return this._productId;
  }
  set productId(value: number) {
    this._productId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttractionDetailsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttractionDetailsRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      productId: this.productId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttractionDetailsRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      productId: this.productId
    };
  }
}
export module AttractionDetailsRequest {
  /**
   * Standard JavaScript object representation for AttractionDetailsRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    productId: number;
  }

  /**
   * Protobuf JSON representation for AttractionDetailsRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    productId: number;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AttractionDetailsResponse
 */
export class AttractionDetailsResponse implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AttractionDetailsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttractionDetailsResponse();
    AttractionDetailsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttractionDetailsResponse) {
    _instance.productId = _instance.productId || 0;
    _instance.languageCode = _instance.languageCode || undefined;
    _instance.productName = _instance.productName || undefined;
    _instance.locationName = _instance.locationName || undefined;
    _instance.reviewRating = _instance.reviewRating || undefined;
    _instance.totalReviews = _instance.totalReviews || undefined;
    _instance.images = _instance.images || [];
    _instance.longitude = _instance.longitude || undefined;
    _instance.latitude = _instance.latitude || undefined;
    _instance.timeZone = _instance.timeZone || undefined;
    _instance.description = _instance.description || undefined;
    _instance.inclusions = _instance.inclusions || [];
    _instance.exclusions = _instance.exclusions || [];
    _instance.additionalDetails = _instance.additionalDetails || [];
    _instance.attributes = _instance.attributes || [];
    _instance.ageBands = _instance.ageBands || [];
    _instance.ticketTypes = _instance.ticketTypes || [];
    _instance.cancellationPolicyDescription =
      _instance.cancellationPolicyDescription || undefined;
    _instance.reviewScoreBreakDown = _instance.reviewScoreBreakDown || [];
    _instance.startLocations = _instance.startLocations || [];
    _instance.endLocations = _instance.endLocations || [];
    _instance.supportedLanguages = _instance.supportedLanguages || [];
    _instance.productOperatingHours = _instance.productOperatingHours || [];
    _instance.durationFromMinutes = _instance.durationFromMinutes || undefined;
    _instance.durationToMinutes = _instance.durationToMinutes || undefined;
    _instance.itinerary = _instance.itinerary || undefined;
    _instance.minGuestsPerBooking = _instance.minGuestsPerBooking || 0;
    _instance.maxGuestsPerBooking = _instance.maxGuestsPerBooking || 0;
    _instance.requiresAdultForBooking =
      _instance.requiresAdultForBooking || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttractionDetailsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.productId = _reader.readInt32();
          break;
        case 2:
          _instance.languageCode = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.languageCode,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.productName = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.productName,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.locationName = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.locationName,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.reviewRating = new googleType000.Decimal();
          _reader.readMessage(
            _instance.reviewRating,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.totalReviews = new googleProtobuf001.Int32Value();
          _reader.readMessage(
            _instance.totalReviews,
            googleProtobuf001.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 7:
          const messageInitializer7 = new Image();
          _reader.readMessage(
            messageInitializer7,
            Image.deserializeBinaryFromReader
          );
          (_instance.images = _instance.images || []).push(messageInitializer7);
          break;
        case 8:
          _instance.longitude = new googleType000.Decimal();
          _reader.readMessage(
            _instance.longitude,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.latitude = new googleType000.Decimal();
          _reader.readMessage(
            _instance.latitude,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        case 10:
          _instance.timeZone = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.timeZone,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 11:
          _instance.description = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.description,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 12:
          const messageInitializer12 = new InclusionExclusion();
          _reader.readMessage(
            messageInitializer12,
            InclusionExclusion.deserializeBinaryFromReader
          );
          (_instance.inclusions = _instance.inclusions || []).push(
            messageInitializer12
          );
          break;
        case 13:
          const messageInitializer13 = new InclusionExclusion();
          _reader.readMessage(
            messageInitializer13,
            InclusionExclusion.deserializeBinaryFromReader
          );
          (_instance.exclusions = _instance.exclusions || []).push(
            messageInitializer13
          );
          break;
        case 14:
          const messageInitializer14 = new AdditionalDetail();
          _reader.readMessage(
            messageInitializer14,
            AdditionalDetail.deserializeBinaryFromReader
          );
          (_instance.additionalDetails =
            _instance.additionalDetails || []).push(messageInitializer14);
          break;
        case 15:
          const messageInitializer15 = new AttractionAttribute();
          _reader.readMessage(
            messageInitializer15,
            AttractionAttribute.deserializeBinaryFromReader
          );
          (_instance.attributes = _instance.attributes || []).push(
            messageInitializer15
          );
          break;
        case 16:
          const messageInitializer16 = new AgeBandModel();
          _reader.readMessage(
            messageInitializer16,
            AgeBandModel.deserializeBinaryFromReader
          );
          (_instance.ageBands = _instance.ageBands || []).push(
            messageInitializer16
          );
          break;
        case 17:
          (_instance.ticketTypes = _instance.ticketTypes || []).push(
            _reader.readString()
          );
          break;
        case 18:
          _instance.cancellationPolicyDescription = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.cancellationPolicyDescription,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 19:
          const messageInitializer19 = new ReviewScore();
          _reader.readMessage(
            messageInitializer19,
            ReviewScore.deserializeBinaryFromReader
          );
          (_instance.reviewScoreBreakDown =
            _instance.reviewScoreBreakDown || []).push(messageInitializer19);
          break;
        case 20:
          const messageInitializer20 = new Location();
          _reader.readMessage(
            messageInitializer20,
            Location.deserializeBinaryFromReader
          );
          (_instance.startLocations = _instance.startLocations || []).push(
            messageInitializer20
          );
          break;
        case 21:
          const messageInitializer21 = new Location();
          _reader.readMessage(
            messageInitializer21,
            Location.deserializeBinaryFromReader
          );
          (_instance.endLocations = _instance.endLocations || []).push(
            messageInitializer21
          );
          break;
        case 22:
          (_instance.supportedLanguages =
            _instance.supportedLanguages || []).push(_reader.readString());
          break;
        case 23:
          const messageInitializer23 = new OperatingHours();
          _reader.readMessage(
            messageInitializer23,
            OperatingHours.deserializeBinaryFromReader
          );
          (_instance.productOperatingHours =
            _instance.productOperatingHours || []).push(messageInitializer23);
          break;
        case 24:
          _instance.durationFromMinutes = new googleProtobuf001.Int32Value();
          _reader.readMessage(
            _instance.durationFromMinutes,
            googleProtobuf001.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 25:
          _instance.durationToMinutes = new googleProtobuf001.Int32Value();
          _reader.readMessage(
            _instance.durationToMinutes,
            googleProtobuf001.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 26:
          _instance.itinerary = new AttractionDetailItinerary();
          _reader.readMessage(
            _instance.itinerary,
            AttractionDetailItinerary.deserializeBinaryFromReader
          );
          break;
        case 27:
          _instance.minGuestsPerBooking = _reader.readInt32();
          break;
        case 28:
          _instance.maxGuestsPerBooking = _reader.readInt32();
          break;
        case 29:
          _instance.requiresAdultForBooking = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    AttractionDetailsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttractionDetailsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.productId) {
      _writer.writeInt32(1, _instance.productId);
    }
    if (_instance.languageCode) {
      _writer.writeMessage(
        2,
        _instance.languageCode as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.productName) {
      _writer.writeMessage(
        3,
        _instance.productName as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.locationName) {
      _writer.writeMessage(
        4,
        _instance.locationName as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.reviewRating) {
      _writer.writeMessage(
        5,
        _instance.reviewRating as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.totalReviews) {
      _writer.writeMessage(
        6,
        _instance.totalReviews as any,
        googleProtobuf001.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.images && _instance.images.length) {
      _writer.writeRepeatedMessage(
        7,
        _instance.images as any,
        Image.serializeBinaryToWriter
      );
    }
    if (_instance.longitude) {
      _writer.writeMessage(
        8,
        _instance.longitude as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.latitude) {
      _writer.writeMessage(
        9,
        _instance.latitude as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.timeZone) {
      _writer.writeMessage(
        10,
        _instance.timeZone as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.description) {
      _writer.writeMessage(
        11,
        _instance.description as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.inclusions && _instance.inclusions.length) {
      _writer.writeRepeatedMessage(
        12,
        _instance.inclusions as any,
        InclusionExclusion.serializeBinaryToWriter
      );
    }
    if (_instance.exclusions && _instance.exclusions.length) {
      _writer.writeRepeatedMessage(
        13,
        _instance.exclusions as any,
        InclusionExclusion.serializeBinaryToWriter
      );
    }
    if (_instance.additionalDetails && _instance.additionalDetails.length) {
      _writer.writeRepeatedMessage(
        14,
        _instance.additionalDetails as any,
        AdditionalDetail.serializeBinaryToWriter
      );
    }
    if (_instance.attributes && _instance.attributes.length) {
      _writer.writeRepeatedMessage(
        15,
        _instance.attributes as any,
        AttractionAttribute.serializeBinaryToWriter
      );
    }
    if (_instance.ageBands && _instance.ageBands.length) {
      _writer.writeRepeatedMessage(
        16,
        _instance.ageBands as any,
        AgeBandModel.serializeBinaryToWriter
      );
    }
    if (_instance.ticketTypes && _instance.ticketTypes.length) {
      _writer.writeRepeatedString(17, _instance.ticketTypes);
    }
    if (_instance.cancellationPolicyDescription) {
      _writer.writeMessage(
        18,
        _instance.cancellationPolicyDescription as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (
      _instance.reviewScoreBreakDown &&
      _instance.reviewScoreBreakDown.length
    ) {
      _writer.writeRepeatedMessage(
        19,
        _instance.reviewScoreBreakDown as any,
        ReviewScore.serializeBinaryToWriter
      );
    }
    if (_instance.startLocations && _instance.startLocations.length) {
      _writer.writeRepeatedMessage(
        20,
        _instance.startLocations as any,
        Location.serializeBinaryToWriter
      );
    }
    if (_instance.endLocations && _instance.endLocations.length) {
      _writer.writeRepeatedMessage(
        21,
        _instance.endLocations as any,
        Location.serializeBinaryToWriter
      );
    }
    if (_instance.supportedLanguages && _instance.supportedLanguages.length) {
      _writer.writeRepeatedString(22, _instance.supportedLanguages);
    }
    if (
      _instance.productOperatingHours &&
      _instance.productOperatingHours.length
    ) {
      _writer.writeRepeatedMessage(
        23,
        _instance.productOperatingHours as any,
        OperatingHours.serializeBinaryToWriter
      );
    }
    if (_instance.durationFromMinutes) {
      _writer.writeMessage(
        24,
        _instance.durationFromMinutes as any,
        googleProtobuf001.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.durationToMinutes) {
      _writer.writeMessage(
        25,
        _instance.durationToMinutes as any,
        googleProtobuf001.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.itinerary) {
      _writer.writeMessage(
        26,
        _instance.itinerary as any,
        AttractionDetailItinerary.serializeBinaryToWriter
      );
    }
    if (_instance.minGuestsPerBooking) {
      _writer.writeInt32(27, _instance.minGuestsPerBooking);
    }
    if (_instance.maxGuestsPerBooking) {
      _writer.writeInt32(28, _instance.maxGuestsPerBooking);
    }
    if (_instance.requiresAdultForBooking) {
      _writer.writeBool(29, _instance.requiresAdultForBooking);
    }
  }

  private _productId: number;
  private _languageCode?: googleProtobuf001.StringValue;
  private _productName?: googleProtobuf001.StringValue;
  private _locationName?: googleProtobuf001.StringValue;
  private _reviewRating?: googleType000.Decimal;
  private _totalReviews?: googleProtobuf001.Int32Value;
  private _images?: Image[];
  private _longitude?: googleType000.Decimal;
  private _latitude?: googleType000.Decimal;
  private _timeZone?: googleProtobuf001.StringValue;
  private _description?: googleProtobuf001.StringValue;
  private _inclusions?: InclusionExclusion[];
  private _exclusions?: InclusionExclusion[];
  private _additionalDetails?: AdditionalDetail[];
  private _attributes?: AttractionAttribute[];
  private _ageBands?: AgeBandModel[];
  private _ticketTypes: string[];
  private _cancellationPolicyDescription?: googleProtobuf001.StringValue;
  private _reviewScoreBreakDown?: ReviewScore[];
  private _startLocations?: Location[];
  private _endLocations?: Location[];
  private _supportedLanguages: string[];
  private _productOperatingHours?: OperatingHours[];
  private _durationFromMinutes?: googleProtobuf001.Int32Value;
  private _durationToMinutes?: googleProtobuf001.Int32Value;
  private _itinerary?: AttractionDetailItinerary;
  private _minGuestsPerBooking: number;
  private _maxGuestsPerBooking: number;
  private _requiresAdultForBooking: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttractionDetailsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttractionDetailsResponse.AsObject>) {
    _value = _value || {};
    this.productId = _value.productId;
    this.languageCode = _value.languageCode
      ? new googleProtobuf001.StringValue(_value.languageCode)
      : undefined;
    this.productName = _value.productName
      ? new googleProtobuf001.StringValue(_value.productName)
      : undefined;
    this.locationName = _value.locationName
      ? new googleProtobuf001.StringValue(_value.locationName)
      : undefined;
    this.reviewRating = _value.reviewRating
      ? new googleType000.Decimal(_value.reviewRating)
      : undefined;
    this.totalReviews = _value.totalReviews
      ? new googleProtobuf001.Int32Value(_value.totalReviews)
      : undefined;
    this.images = (_value.images || []).map(m => new Image(m));
    this.longitude = _value.longitude
      ? new googleType000.Decimal(_value.longitude)
      : undefined;
    this.latitude = _value.latitude
      ? new googleType000.Decimal(_value.latitude)
      : undefined;
    this.timeZone = _value.timeZone
      ? new googleProtobuf001.StringValue(_value.timeZone)
      : undefined;
    this.description = _value.description
      ? new googleProtobuf001.StringValue(_value.description)
      : undefined;
    this.inclusions = (_value.inclusions || []).map(
      m => new InclusionExclusion(m)
    );
    this.exclusions = (_value.exclusions || []).map(
      m => new InclusionExclusion(m)
    );
    this.additionalDetails = (_value.additionalDetails || []).map(
      m => new AdditionalDetail(m)
    );
    this.attributes = (_value.attributes || []).map(
      m => new AttractionAttribute(m)
    );
    this.ageBands = (_value.ageBands || []).map(m => new AgeBandModel(m));
    this.ticketTypes = (_value.ticketTypes || []).slice();
    this.cancellationPolicyDescription = _value.cancellationPolicyDescription
      ? new googleProtobuf001.StringValue(_value.cancellationPolicyDescription)
      : undefined;
    this.reviewScoreBreakDown = (_value.reviewScoreBreakDown || []).map(
      m => new ReviewScore(m)
    );
    this.startLocations = (_value.startLocations || []).map(
      m => new Location(m)
    );
    this.endLocations = (_value.endLocations || []).map(m => new Location(m));
    this.supportedLanguages = (_value.supportedLanguages || []).slice();
    this.productOperatingHours = (_value.productOperatingHours || []).map(
      m => new OperatingHours(m)
    );
    this.durationFromMinutes = _value.durationFromMinutes
      ? new googleProtobuf001.Int32Value(_value.durationFromMinutes)
      : undefined;
    this.durationToMinutes = _value.durationToMinutes
      ? new googleProtobuf001.Int32Value(_value.durationToMinutes)
      : undefined;
    this.itinerary = _value.itinerary
      ? new AttractionDetailItinerary(_value.itinerary)
      : undefined;
    this.minGuestsPerBooking = _value.minGuestsPerBooking;
    this.maxGuestsPerBooking = _value.maxGuestsPerBooking;
    this.requiresAdultForBooking = _value.requiresAdultForBooking;
    AttractionDetailsResponse.refineValues(this);
  }
  get productId(): number {
    return this._productId;
  }
  set productId(value: number) {
    this._productId = value;
  }
  get languageCode(): googleProtobuf001.StringValue | undefined {
    return this._languageCode;
  }
  set languageCode(value: googleProtobuf001.StringValue | undefined) {
    this._languageCode = value;
  }
  get productName(): googleProtobuf001.StringValue | undefined {
    return this._productName;
  }
  set productName(value: googleProtobuf001.StringValue | undefined) {
    this._productName = value;
  }
  get locationName(): googleProtobuf001.StringValue | undefined {
    return this._locationName;
  }
  set locationName(value: googleProtobuf001.StringValue | undefined) {
    this._locationName = value;
  }
  get reviewRating(): googleType000.Decimal | undefined {
    return this._reviewRating;
  }
  set reviewRating(value: googleType000.Decimal | undefined) {
    this._reviewRating = value;
  }
  get totalReviews(): googleProtobuf001.Int32Value | undefined {
    return this._totalReviews;
  }
  set totalReviews(value: googleProtobuf001.Int32Value | undefined) {
    this._totalReviews = value;
  }
  get images(): Image[] | undefined {
    return this._images;
  }
  set images(value: Image[] | undefined) {
    this._images = value;
  }
  get longitude(): googleType000.Decimal | undefined {
    return this._longitude;
  }
  set longitude(value: googleType000.Decimal | undefined) {
    this._longitude = value;
  }
  get latitude(): googleType000.Decimal | undefined {
    return this._latitude;
  }
  set latitude(value: googleType000.Decimal | undefined) {
    this._latitude = value;
  }
  get timeZone(): googleProtobuf001.StringValue | undefined {
    return this._timeZone;
  }
  set timeZone(value: googleProtobuf001.StringValue | undefined) {
    this._timeZone = value;
  }
  get description(): googleProtobuf001.StringValue | undefined {
    return this._description;
  }
  set description(value: googleProtobuf001.StringValue | undefined) {
    this._description = value;
  }
  get inclusions(): InclusionExclusion[] | undefined {
    return this._inclusions;
  }
  set inclusions(value: InclusionExclusion[] | undefined) {
    this._inclusions = value;
  }
  get exclusions(): InclusionExclusion[] | undefined {
    return this._exclusions;
  }
  set exclusions(value: InclusionExclusion[] | undefined) {
    this._exclusions = value;
  }
  get additionalDetails(): AdditionalDetail[] | undefined {
    return this._additionalDetails;
  }
  set additionalDetails(value: AdditionalDetail[] | undefined) {
    this._additionalDetails = value;
  }
  get attributes(): AttractionAttribute[] | undefined {
    return this._attributes;
  }
  set attributes(value: AttractionAttribute[] | undefined) {
    this._attributes = value;
  }
  get ageBands(): AgeBandModel[] | undefined {
    return this._ageBands;
  }
  set ageBands(value: AgeBandModel[] | undefined) {
    this._ageBands = value;
  }
  get ticketTypes(): string[] {
    return this._ticketTypes;
  }
  set ticketTypes(value: string[]) {
    this._ticketTypes = value;
  }
  get cancellationPolicyDescription():
    | googleProtobuf001.StringValue
    | undefined {
    return this._cancellationPolicyDescription;
  }
  set cancellationPolicyDescription(
    value: googleProtobuf001.StringValue | undefined
  ) {
    this._cancellationPolicyDescription = value;
  }
  get reviewScoreBreakDown(): ReviewScore[] | undefined {
    return this._reviewScoreBreakDown;
  }
  set reviewScoreBreakDown(value: ReviewScore[] | undefined) {
    this._reviewScoreBreakDown = value;
  }
  get startLocations(): Location[] | undefined {
    return this._startLocations;
  }
  set startLocations(value: Location[] | undefined) {
    this._startLocations = value;
  }
  get endLocations(): Location[] | undefined {
    return this._endLocations;
  }
  set endLocations(value: Location[] | undefined) {
    this._endLocations = value;
  }
  get supportedLanguages(): string[] {
    return this._supportedLanguages;
  }
  set supportedLanguages(value: string[]) {
    this._supportedLanguages = value;
  }
  get productOperatingHours(): OperatingHours[] | undefined {
    return this._productOperatingHours;
  }
  set productOperatingHours(value: OperatingHours[] | undefined) {
    this._productOperatingHours = value;
  }
  get durationFromMinutes(): googleProtobuf001.Int32Value | undefined {
    return this._durationFromMinutes;
  }
  set durationFromMinutes(value: googleProtobuf001.Int32Value | undefined) {
    this._durationFromMinutes = value;
  }
  get durationToMinutes(): googleProtobuf001.Int32Value | undefined {
    return this._durationToMinutes;
  }
  set durationToMinutes(value: googleProtobuf001.Int32Value | undefined) {
    this._durationToMinutes = value;
  }
  get itinerary(): AttractionDetailItinerary | undefined {
    return this._itinerary;
  }
  set itinerary(value: AttractionDetailItinerary | undefined) {
    this._itinerary = value;
  }
  get minGuestsPerBooking(): number {
    return this._minGuestsPerBooking;
  }
  set minGuestsPerBooking(value: number) {
    this._minGuestsPerBooking = value;
  }
  get maxGuestsPerBooking(): number {
    return this._maxGuestsPerBooking;
  }
  set maxGuestsPerBooking(value: number) {
    this._maxGuestsPerBooking = value;
  }
  get requiresAdultForBooking(): boolean {
    return this._requiresAdultForBooking;
  }
  set requiresAdultForBooking(value: boolean) {
    this._requiresAdultForBooking = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttractionDetailsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttractionDetailsResponse.AsObject {
    return {
      productId: this.productId,
      languageCode: this.languageCode
        ? this.languageCode.toObject()
        : undefined,
      productName: this.productName ? this.productName.toObject() : undefined,
      locationName: this.locationName
        ? this.locationName.toObject()
        : undefined,
      reviewRating: this.reviewRating
        ? this.reviewRating.toObject()
        : undefined,
      totalReviews: this.totalReviews
        ? this.totalReviews.toObject()
        : undefined,
      images: (this.images || []).map(m => m.toObject()),
      longitude: this.longitude ? this.longitude.toObject() : undefined,
      latitude: this.latitude ? this.latitude.toObject() : undefined,
      timeZone: this.timeZone ? this.timeZone.toObject() : undefined,
      description: this.description ? this.description.toObject() : undefined,
      inclusions: (this.inclusions || []).map(m => m.toObject()),
      exclusions: (this.exclusions || []).map(m => m.toObject()),
      additionalDetails: (this.additionalDetails || []).map(m => m.toObject()),
      attributes: (this.attributes || []).map(m => m.toObject()),
      ageBands: (this.ageBands || []).map(m => m.toObject()),
      ticketTypes: (this.ticketTypes || []).slice(),
      cancellationPolicyDescription: this.cancellationPolicyDescription
        ? this.cancellationPolicyDescription.toObject()
        : undefined,
      reviewScoreBreakDown: (this.reviewScoreBreakDown || []).map(m =>
        m.toObject()
      ),
      startLocations: (this.startLocations || []).map(m => m.toObject()),
      endLocations: (this.endLocations || []).map(m => m.toObject()),
      supportedLanguages: (this.supportedLanguages || []).slice(),
      productOperatingHours: (this.productOperatingHours || []).map(m =>
        m.toObject()
      ),
      durationFromMinutes: this.durationFromMinutes
        ? this.durationFromMinutes.toObject()
        : undefined,
      durationToMinutes: this.durationToMinutes
        ? this.durationToMinutes.toObject()
        : undefined,
      itinerary: this.itinerary ? this.itinerary.toObject() : undefined,
      minGuestsPerBooking: this.minGuestsPerBooking,
      maxGuestsPerBooking: this.maxGuestsPerBooking,
      requiresAdultForBooking: this.requiresAdultForBooking
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttractionDetailsResponse.AsProtobufJSON {
    return {
      productId: this.productId,
      languageCode: this.languageCode
        ? this.languageCode.toProtobufJSON(options)
        : null,
      productName: this.productName
        ? this.productName.toProtobufJSON(options)
        : null,
      locationName: this.locationName
        ? this.locationName.toProtobufJSON(options)
        : null,
      reviewRating: this.reviewRating
        ? this.reviewRating.toProtobufJSON(options)
        : null,
      totalReviews: this.totalReviews
        ? this.totalReviews.toProtobufJSON(options)
        : null,
      images: (this.images || []).map(m => m.toProtobufJSON(options)),
      longitude: this.longitude ? this.longitude.toProtobufJSON(options) : null,
      latitude: this.latitude ? this.latitude.toProtobufJSON(options) : null,
      timeZone: this.timeZone ? this.timeZone.toProtobufJSON(options) : null,
      description: this.description
        ? this.description.toProtobufJSON(options)
        : null,
      inclusions: (this.inclusions || []).map(m => m.toProtobufJSON(options)),
      exclusions: (this.exclusions || []).map(m => m.toProtobufJSON(options)),
      additionalDetails: (this.additionalDetails || []).map(m =>
        m.toProtobufJSON(options)
      ),
      attributes: (this.attributes || []).map(m => m.toProtobufJSON(options)),
      ageBands: (this.ageBands || []).map(m => m.toProtobufJSON(options)),
      ticketTypes: (this.ticketTypes || []).slice(),
      cancellationPolicyDescription: this.cancellationPolicyDescription
        ? this.cancellationPolicyDescription.toProtobufJSON(options)
        : null,
      reviewScoreBreakDown: (this.reviewScoreBreakDown || []).map(m =>
        m.toProtobufJSON(options)
      ),
      startLocations: (this.startLocations || []).map(m =>
        m.toProtobufJSON(options)
      ),
      endLocations: (this.endLocations || []).map(m =>
        m.toProtobufJSON(options)
      ),
      supportedLanguages: (this.supportedLanguages || []).slice(),
      productOperatingHours: (this.productOperatingHours || []).map(m =>
        m.toProtobufJSON(options)
      ),
      durationFromMinutes: this.durationFromMinutes
        ? this.durationFromMinutes.toProtobufJSON(options)
        : null,
      durationToMinutes: this.durationToMinutes
        ? this.durationToMinutes.toProtobufJSON(options)
        : null,
      itinerary: this.itinerary ? this.itinerary.toProtobufJSON(options) : null,
      minGuestsPerBooking: this.minGuestsPerBooking,
      maxGuestsPerBooking: this.maxGuestsPerBooking,
      requiresAdultForBooking: this.requiresAdultForBooking
    };
  }
}
export module AttractionDetailsResponse {
  /**
   * Standard JavaScript object representation for AttractionDetailsResponse
   */
  export interface AsObject {
    productId: number;
    languageCode?: googleProtobuf001.StringValue.AsObject;
    productName?: googleProtobuf001.StringValue.AsObject;
    locationName?: googleProtobuf001.StringValue.AsObject;
    reviewRating?: googleType000.Decimal.AsObject;
    totalReviews?: googleProtobuf001.Int32Value.AsObject;
    images?: Image.AsObject[];
    longitude?: googleType000.Decimal.AsObject;
    latitude?: googleType000.Decimal.AsObject;
    timeZone?: googleProtobuf001.StringValue.AsObject;
    description?: googleProtobuf001.StringValue.AsObject;
    inclusions?: InclusionExclusion.AsObject[];
    exclusions?: InclusionExclusion.AsObject[];
    additionalDetails?: AdditionalDetail.AsObject[];
    attributes?: AttractionAttribute.AsObject[];
    ageBands?: AgeBandModel.AsObject[];
    ticketTypes: string[];
    cancellationPolicyDescription?: googleProtobuf001.StringValue.AsObject;
    reviewScoreBreakDown?: ReviewScore.AsObject[];
    startLocations?: Location.AsObject[];
    endLocations?: Location.AsObject[];
    supportedLanguages: string[];
    productOperatingHours?: OperatingHours.AsObject[];
    durationFromMinutes?: googleProtobuf001.Int32Value.AsObject;
    durationToMinutes?: googleProtobuf001.Int32Value.AsObject;
    itinerary?: AttractionDetailItinerary.AsObject;
    minGuestsPerBooking: number;
    maxGuestsPerBooking: number;
    requiresAdultForBooking: boolean;
  }

  /**
   * Protobuf JSON representation for AttractionDetailsResponse
   */
  export interface AsProtobufJSON {
    productId: number;
    languageCode: googleProtobuf001.StringValue.AsProtobufJSON | null;
    productName: googleProtobuf001.StringValue.AsProtobufJSON | null;
    locationName: googleProtobuf001.StringValue.AsProtobufJSON | null;
    reviewRating: googleType000.Decimal.AsProtobufJSON | null;
    totalReviews: googleProtobuf001.Int32Value.AsProtobufJSON | null;
    images: Image.AsProtobufJSON[] | null;
    longitude: googleType000.Decimal.AsProtobufJSON | null;
    latitude: googleType000.Decimal.AsProtobufJSON | null;
    timeZone: googleProtobuf001.StringValue.AsProtobufJSON | null;
    description: googleProtobuf001.StringValue.AsProtobufJSON | null;
    inclusions: InclusionExclusion.AsProtobufJSON[] | null;
    exclusions: InclusionExclusion.AsProtobufJSON[] | null;
    additionalDetails: AdditionalDetail.AsProtobufJSON[] | null;
    attributes: AttractionAttribute.AsProtobufJSON[] | null;
    ageBands: AgeBandModel.AsProtobufJSON[] | null;
    ticketTypes: string[];
    cancellationPolicyDescription: googleProtobuf001.StringValue.AsProtobufJSON | null;
    reviewScoreBreakDown: ReviewScore.AsProtobufJSON[] | null;
    startLocations: Location.AsProtobufJSON[] | null;
    endLocations: Location.AsProtobufJSON[] | null;
    supportedLanguages: string[];
    productOperatingHours: OperatingHours.AsProtobufJSON[] | null;
    durationFromMinutes: googleProtobuf001.Int32Value.AsProtobufJSON | null;
    durationToMinutes: googleProtobuf001.Int32Value.AsProtobufJSON | null;
    itinerary: AttractionDetailItinerary.AsProtobufJSON | null;
    minGuestsPerBooking: number;
    maxGuestsPerBooking: number;
    requiresAdultForBooking: boolean;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.InclusionExclusion
 */
export class InclusionExclusion implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.InclusionExclusion';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new InclusionExclusion();
    InclusionExclusion.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: InclusionExclusion) {
    _instance.category = _instance.category || undefined;
    _instance.description = _instance.description || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: InclusionExclusion,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.category = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.category,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.description = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.description,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    InclusionExclusion.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: InclusionExclusion,
    _writer: BinaryWriter
  ) {
    if (_instance.category) {
      _writer.writeMessage(
        1,
        _instance.category as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.description) {
      _writer.writeMessage(
        2,
        _instance.description as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _category?: googleProtobuf001.StringValue;
  private _description?: googleProtobuf001.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of InclusionExclusion to deeply clone from
   */
  constructor(_value?: RecursivePartial<InclusionExclusion.AsObject>) {
    _value = _value || {};
    this.category = _value.category
      ? new googleProtobuf001.StringValue(_value.category)
      : undefined;
    this.description = _value.description
      ? new googleProtobuf001.StringValue(_value.description)
      : undefined;
    InclusionExclusion.refineValues(this);
  }
  get category(): googleProtobuf001.StringValue | undefined {
    return this._category;
  }
  set category(value: googleProtobuf001.StringValue | undefined) {
    this._category = value;
  }
  get description(): googleProtobuf001.StringValue | undefined {
    return this._description;
  }
  set description(value: googleProtobuf001.StringValue | undefined) {
    this._description = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    InclusionExclusion.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): InclusionExclusion.AsObject {
    return {
      category: this.category ? this.category.toObject() : undefined,
      description: this.description ? this.description.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): InclusionExclusion.AsProtobufJSON {
    return {
      category: this.category ? this.category.toProtobufJSON(options) : null,
      description: this.description
        ? this.description.toProtobufJSON(options)
        : null
    };
  }
}
export module InclusionExclusion {
  /**
   * Standard JavaScript object representation for InclusionExclusion
   */
  export interface AsObject {
    category?: googleProtobuf001.StringValue.AsObject;
    description?: googleProtobuf001.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for InclusionExclusion
   */
  export interface AsProtobufJSON {
    category: googleProtobuf001.StringValue.AsProtobufJSON | null;
    description: googleProtobuf001.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.OperatingHours
 */
export class OperatingHours implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.OperatingHours';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new OperatingHours();
    OperatingHours.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: OperatingHours) {
    _instance.productOptionCode = _instance.productOptionCode || undefined;
    _instance.productOptionTitle = _instance.productOptionTitle || undefined;
    _instance.seasonStartDate = _instance.seasonStartDate || undefined;
    _instance.seasonEndDate = _instance.seasonEndDate || undefined;
    _instance.operatingDaysAndTimes = _instance.operatingDaysAndTimes || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: OperatingHours,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.productOptionCode = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.productOptionCode,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.productOptionTitle = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.productOptionTitle,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.seasonStartDate = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.seasonStartDate,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.seasonEndDate = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.seasonEndDate,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 5:
          const messageInitializer5 = new OperatingDaysAndTime();
          _reader.readMessage(
            messageInitializer5,
            OperatingDaysAndTime.deserializeBinaryFromReader
          );
          (_instance.operatingDaysAndTimes =
            _instance.operatingDaysAndTimes || []).push(messageInitializer5);
          break;
        default:
          _reader.skipField();
      }
    }

    OperatingHours.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: OperatingHours,
    _writer: BinaryWriter
  ) {
    if (_instance.productOptionCode) {
      _writer.writeMessage(
        1,
        _instance.productOptionCode as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.productOptionTitle) {
      _writer.writeMessage(
        2,
        _instance.productOptionTitle as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.seasonStartDate) {
      _writer.writeMessage(
        3,
        _instance.seasonStartDate as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.seasonEndDate) {
      _writer.writeMessage(
        4,
        _instance.seasonEndDate as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (
      _instance.operatingDaysAndTimes &&
      _instance.operatingDaysAndTimes.length
    ) {
      _writer.writeRepeatedMessage(
        5,
        _instance.operatingDaysAndTimes as any,
        OperatingDaysAndTime.serializeBinaryToWriter
      );
    }
  }

  private _productOptionCode?: googleProtobuf001.StringValue;
  private _productOptionTitle?: googleProtobuf001.StringValue;
  private _seasonStartDate?: googleProtobuf001.StringValue;
  private _seasonEndDate?: googleProtobuf001.StringValue;
  private _operatingDaysAndTimes?: OperatingDaysAndTime[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of OperatingHours to deeply clone from
   */
  constructor(_value?: RecursivePartial<OperatingHours.AsObject>) {
    _value = _value || {};
    this.productOptionCode = _value.productOptionCode
      ? new googleProtobuf001.StringValue(_value.productOptionCode)
      : undefined;
    this.productOptionTitle = _value.productOptionTitle
      ? new googleProtobuf001.StringValue(_value.productOptionTitle)
      : undefined;
    this.seasonStartDate = _value.seasonStartDate
      ? new googleProtobuf001.StringValue(_value.seasonStartDate)
      : undefined;
    this.seasonEndDate = _value.seasonEndDate
      ? new googleProtobuf001.StringValue(_value.seasonEndDate)
      : undefined;
    this.operatingDaysAndTimes = (_value.operatingDaysAndTimes || []).map(
      m => new OperatingDaysAndTime(m)
    );
    OperatingHours.refineValues(this);
  }
  get productOptionCode(): googleProtobuf001.StringValue | undefined {
    return this._productOptionCode;
  }
  set productOptionCode(value: googleProtobuf001.StringValue | undefined) {
    this._productOptionCode = value;
  }
  get productOptionTitle(): googleProtobuf001.StringValue | undefined {
    return this._productOptionTitle;
  }
  set productOptionTitle(value: googleProtobuf001.StringValue | undefined) {
    this._productOptionTitle = value;
  }
  get seasonStartDate(): googleProtobuf001.StringValue | undefined {
    return this._seasonStartDate;
  }
  set seasonStartDate(value: googleProtobuf001.StringValue | undefined) {
    this._seasonStartDate = value;
  }
  get seasonEndDate(): googleProtobuf001.StringValue | undefined {
    return this._seasonEndDate;
  }
  set seasonEndDate(value: googleProtobuf001.StringValue | undefined) {
    this._seasonEndDate = value;
  }
  get operatingDaysAndTimes(): OperatingDaysAndTime[] | undefined {
    return this._operatingDaysAndTimes;
  }
  set operatingDaysAndTimes(value: OperatingDaysAndTime[] | undefined) {
    this._operatingDaysAndTimes = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    OperatingHours.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): OperatingHours.AsObject {
    return {
      productOptionCode: this.productOptionCode
        ? this.productOptionCode.toObject()
        : undefined,
      productOptionTitle: this.productOptionTitle
        ? this.productOptionTitle.toObject()
        : undefined,
      seasonStartDate: this.seasonStartDate
        ? this.seasonStartDate.toObject()
        : undefined,
      seasonEndDate: this.seasonEndDate
        ? this.seasonEndDate.toObject()
        : undefined,
      operatingDaysAndTimes: (this.operatingDaysAndTimes || []).map(m =>
        m.toObject()
      )
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): OperatingHours.AsProtobufJSON {
    return {
      productOptionCode: this.productOptionCode
        ? this.productOptionCode.toProtobufJSON(options)
        : null,
      productOptionTitle: this.productOptionTitle
        ? this.productOptionTitle.toProtobufJSON(options)
        : null,
      seasonStartDate: this.seasonStartDate
        ? this.seasonStartDate.toProtobufJSON(options)
        : null,
      seasonEndDate: this.seasonEndDate
        ? this.seasonEndDate.toProtobufJSON(options)
        : null,
      operatingDaysAndTimes: (this.operatingDaysAndTimes || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module OperatingHours {
  /**
   * Standard JavaScript object representation for OperatingHours
   */
  export interface AsObject {
    productOptionCode?: googleProtobuf001.StringValue.AsObject;
    productOptionTitle?: googleProtobuf001.StringValue.AsObject;
    seasonStartDate?: googleProtobuf001.StringValue.AsObject;
    seasonEndDate?: googleProtobuf001.StringValue.AsObject;
    operatingDaysAndTimes?: OperatingDaysAndTime.AsObject[];
  }

  /**
   * Protobuf JSON representation for OperatingHours
   */
  export interface AsProtobufJSON {
    productOptionCode: googleProtobuf001.StringValue.AsProtobufJSON | null;
    productOptionTitle: googleProtobuf001.StringValue.AsProtobufJSON | null;
    seasonStartDate: googleProtobuf001.StringValue.AsProtobufJSON | null;
    seasonEndDate: googleProtobuf001.StringValue.AsProtobufJSON | null;
    operatingDaysAndTimes: OperatingDaysAndTime.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.OperatingDaysAndTime
 */
export class OperatingDaysAndTime implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.OperatingDaysAndTime';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new OperatingDaysAndTime();
    OperatingDaysAndTime.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: OperatingDaysAndTime) {
    _instance.opensAt = _instance.opensAt || undefined;
    _instance.closesAt = _instance.closesAt || undefined;
    _instance.daysOfWeek = _instance.daysOfWeek || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: OperatingDaysAndTime,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.opensAt = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.opensAt,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.closesAt = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.closesAt,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          (_instance.daysOfWeek = _instance.daysOfWeek || []).push(
            _reader.readString()
          );
          break;
        default:
          _reader.skipField();
      }
    }

    OperatingDaysAndTime.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: OperatingDaysAndTime,
    _writer: BinaryWriter
  ) {
    if (_instance.opensAt) {
      _writer.writeMessage(
        1,
        _instance.opensAt as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.closesAt) {
      _writer.writeMessage(
        2,
        _instance.closesAt as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.daysOfWeek && _instance.daysOfWeek.length) {
      _writer.writeRepeatedString(3, _instance.daysOfWeek);
    }
  }

  private _opensAt?: googleProtobuf001.StringValue;
  private _closesAt?: googleProtobuf001.StringValue;
  private _daysOfWeek: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of OperatingDaysAndTime to deeply clone from
   */
  constructor(_value?: RecursivePartial<OperatingDaysAndTime.AsObject>) {
    _value = _value || {};
    this.opensAt = _value.opensAt
      ? new googleProtobuf001.StringValue(_value.opensAt)
      : undefined;
    this.closesAt = _value.closesAt
      ? new googleProtobuf001.StringValue(_value.closesAt)
      : undefined;
    this.daysOfWeek = (_value.daysOfWeek || []).slice();
    OperatingDaysAndTime.refineValues(this);
  }
  get opensAt(): googleProtobuf001.StringValue | undefined {
    return this._opensAt;
  }
  set opensAt(value: googleProtobuf001.StringValue | undefined) {
    this._opensAt = value;
  }
  get closesAt(): googleProtobuf001.StringValue | undefined {
    return this._closesAt;
  }
  set closesAt(value: googleProtobuf001.StringValue | undefined) {
    this._closesAt = value;
  }
  get daysOfWeek(): string[] {
    return this._daysOfWeek;
  }
  set daysOfWeek(value: string[]) {
    this._daysOfWeek = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    OperatingDaysAndTime.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): OperatingDaysAndTime.AsObject {
    return {
      opensAt: this.opensAt ? this.opensAt.toObject() : undefined,
      closesAt: this.closesAt ? this.closesAt.toObject() : undefined,
      daysOfWeek: (this.daysOfWeek || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): OperatingDaysAndTime.AsProtobufJSON {
    return {
      opensAt: this.opensAt ? this.opensAt.toProtobufJSON(options) : null,
      closesAt: this.closesAt ? this.closesAt.toProtobufJSON(options) : null,
      daysOfWeek: (this.daysOfWeek || []).slice()
    };
  }
}
export module OperatingDaysAndTime {
  /**
   * Standard JavaScript object representation for OperatingDaysAndTime
   */
  export interface AsObject {
    opensAt?: googleProtobuf001.StringValue.AsObject;
    closesAt?: googleProtobuf001.StringValue.AsObject;
    daysOfWeek: string[];
  }

  /**
   * Protobuf JSON representation for OperatingDaysAndTime
   */
  export interface AsProtobufJSON {
    opensAt: googleProtobuf001.StringValue.AsProtobufJSON | null;
    closesAt: googleProtobuf001.StringValue.AsProtobufJSON | null;
    daysOfWeek: string[];
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.ReviewScore
 */
export class ReviewScore implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.ReviewScore';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ReviewScore();
    ReviewScore.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ReviewScore) {
    _instance.rating = _instance.rating || undefined;
    _instance.count = _instance.count || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ReviewScore,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.rating = new googleType000.Decimal();
          _reader.readMessage(
            _instance.rating,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.count = new googleProtobuf001.Int32Value();
          _reader.readMessage(
            _instance.count,
            googleProtobuf001.Int32Value.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ReviewScore.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ReviewScore,
    _writer: BinaryWriter
  ) {
    if (_instance.rating) {
      _writer.writeMessage(
        1,
        _instance.rating as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.count) {
      _writer.writeMessage(
        2,
        _instance.count as any,
        googleProtobuf001.Int32Value.serializeBinaryToWriter
      );
    }
  }

  private _rating?: googleType000.Decimal;
  private _count?: googleProtobuf001.Int32Value;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ReviewScore to deeply clone from
   */
  constructor(_value?: RecursivePartial<ReviewScore.AsObject>) {
    _value = _value || {};
    this.rating = _value.rating
      ? new googleType000.Decimal(_value.rating)
      : undefined;
    this.count = _value.count
      ? new googleProtobuf001.Int32Value(_value.count)
      : undefined;
    ReviewScore.refineValues(this);
  }
  get rating(): googleType000.Decimal | undefined {
    return this._rating;
  }
  set rating(value: googleType000.Decimal | undefined) {
    this._rating = value;
  }
  get count(): googleProtobuf001.Int32Value | undefined {
    return this._count;
  }
  set count(value: googleProtobuf001.Int32Value | undefined) {
    this._count = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ReviewScore.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ReviewScore.AsObject {
    return {
      rating: this.rating ? this.rating.toObject() : undefined,
      count: this.count ? this.count.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ReviewScore.AsProtobufJSON {
    return {
      rating: this.rating ? this.rating.toProtobufJSON(options) : null,
      count: this.count ? this.count.toProtobufJSON(options) : null
    };
  }
}
export module ReviewScore {
  /**
   * Standard JavaScript object representation for ReviewScore
   */
  export interface AsObject {
    rating?: googleType000.Decimal.AsObject;
    count?: googleProtobuf001.Int32Value.AsObject;
  }

  /**
   * Protobuf JSON representation for ReviewScore
   */
  export interface AsProtobufJSON {
    rating: googleType000.Decimal.AsProtobufJSON | null;
    count: googleProtobuf001.Int32Value.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AgeBandModel
 */
export class AgeBandModel implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AgeBandModel';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AgeBandModel();
    AgeBandModel.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AgeBandModel) {
    _instance.ageBand = _instance.ageBand || undefined;
    _instance.startAge = _instance.startAge || 0;
    _instance.endAge = _instance.endAge || 0;
    _instance.minTravelersPerBooking = _instance.minTravelersPerBooking || 0;
    _instance.maxTravelersPerBooking = _instance.maxTravelersPerBooking || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AgeBandModel,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.ageBand = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.ageBand,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.startAge = _reader.readInt32();
          break;
        case 3:
          _instance.endAge = _reader.readInt32();
          break;
        case 4:
          _instance.minTravelersPerBooking = _reader.readInt32();
          break;
        case 5:
          _instance.maxTravelersPerBooking = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    AgeBandModel.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AgeBandModel,
    _writer: BinaryWriter
  ) {
    if (_instance.ageBand) {
      _writer.writeMessage(
        1,
        _instance.ageBand as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.startAge) {
      _writer.writeInt32(2, _instance.startAge);
    }
    if (_instance.endAge) {
      _writer.writeInt32(3, _instance.endAge);
    }
    if (_instance.minTravelersPerBooking) {
      _writer.writeInt32(4, _instance.minTravelersPerBooking);
    }
    if (_instance.maxTravelersPerBooking) {
      _writer.writeInt32(5, _instance.maxTravelersPerBooking);
    }
  }

  private _ageBand?: googleProtobuf001.StringValue;
  private _startAge: number;
  private _endAge: number;
  private _minTravelersPerBooking: number;
  private _maxTravelersPerBooking: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AgeBandModel to deeply clone from
   */
  constructor(_value?: RecursivePartial<AgeBandModel.AsObject>) {
    _value = _value || {};
    this.ageBand = _value.ageBand
      ? new googleProtobuf001.StringValue(_value.ageBand)
      : undefined;
    this.startAge = _value.startAge;
    this.endAge = _value.endAge;
    this.minTravelersPerBooking = _value.minTravelersPerBooking;
    this.maxTravelersPerBooking = _value.maxTravelersPerBooking;
    AgeBandModel.refineValues(this);
  }
  get ageBand(): googleProtobuf001.StringValue | undefined {
    return this._ageBand;
  }
  set ageBand(value: googleProtobuf001.StringValue | undefined) {
    this._ageBand = value;
  }
  get startAge(): number {
    return this._startAge;
  }
  set startAge(value: number) {
    this._startAge = value;
  }
  get endAge(): number {
    return this._endAge;
  }
  set endAge(value: number) {
    this._endAge = value;
  }
  get minTravelersPerBooking(): number {
    return this._minTravelersPerBooking;
  }
  set minTravelersPerBooking(value: number) {
    this._minTravelersPerBooking = value;
  }
  get maxTravelersPerBooking(): number {
    return this._maxTravelersPerBooking;
  }
  set maxTravelersPerBooking(value: number) {
    this._maxTravelersPerBooking = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AgeBandModel.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AgeBandModel.AsObject {
    return {
      ageBand: this.ageBand ? this.ageBand.toObject() : undefined,
      startAge: this.startAge,
      endAge: this.endAge,
      minTravelersPerBooking: this.minTravelersPerBooking,
      maxTravelersPerBooking: this.maxTravelersPerBooking
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AgeBandModel.AsProtobufJSON {
    return {
      ageBand: this.ageBand ? this.ageBand.toProtobufJSON(options) : null,
      startAge: this.startAge,
      endAge: this.endAge,
      minTravelersPerBooking: this.minTravelersPerBooking,
      maxTravelersPerBooking: this.maxTravelersPerBooking
    };
  }
}
export module AgeBandModel {
  /**
   * Standard JavaScript object representation for AgeBandModel
   */
  export interface AsObject {
    ageBand?: googleProtobuf001.StringValue.AsObject;
    startAge: number;
    endAge: number;
    minTravelersPerBooking: number;
    maxTravelersPerBooking: number;
  }

  /**
   * Protobuf JSON representation for AgeBandModel
   */
  export interface AsProtobufJSON {
    ageBand: googleProtobuf001.StringValue.AsProtobufJSON | null;
    startAge: number;
    endAge: number;
    minTravelersPerBooking: number;
    maxTravelersPerBooking: number;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AttractionAttribute
 */
export class AttractionAttribute implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AttractionAttribute';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttractionAttribute();
    AttractionAttribute.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttractionAttribute) {
    _instance.attributeId = _instance.attributeId || 0;
    _instance.attributeName = _instance.attributeName || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttractionAttribute,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.attributeId = _reader.readInt32();
          break;
        case 2:
          _instance.attributeName = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.attributeName,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AttractionAttribute.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttractionAttribute,
    _writer: BinaryWriter
  ) {
    if (_instance.attributeId) {
      _writer.writeInt32(1, _instance.attributeId);
    }
    if (_instance.attributeName) {
      _writer.writeMessage(
        2,
        _instance.attributeName as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _attributeId: number;
  private _attributeName?: googleProtobuf001.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttractionAttribute to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttractionAttribute.AsObject>) {
    _value = _value || {};
    this.attributeId = _value.attributeId;
    this.attributeName = _value.attributeName
      ? new googleProtobuf001.StringValue(_value.attributeName)
      : undefined;
    AttractionAttribute.refineValues(this);
  }
  get attributeId(): number {
    return this._attributeId;
  }
  set attributeId(value: number) {
    this._attributeId = value;
  }
  get attributeName(): googleProtobuf001.StringValue | undefined {
    return this._attributeName;
  }
  set attributeName(value: googleProtobuf001.StringValue | undefined) {
    this._attributeName = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttractionAttribute.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttractionAttribute.AsObject {
    return {
      attributeId: this.attributeId,
      attributeName: this.attributeName
        ? this.attributeName.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttractionAttribute.AsProtobufJSON {
    return {
      attributeId: this.attributeId,
      attributeName: this.attributeName
        ? this.attributeName.toProtobufJSON(options)
        : null
    };
  }
}
export module AttractionAttribute {
  /**
   * Standard JavaScript object representation for AttractionAttribute
   */
  export interface AsObject {
    attributeId: number;
    attributeName?: googleProtobuf001.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for AttractionAttribute
   */
  export interface AsProtobufJSON {
    attributeId: number;
    attributeName: googleProtobuf001.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AdditionalDetail
 */
export class AdditionalDetail implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AdditionalDetail';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AdditionalDetail();
    AdditionalDetail.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AdditionalDetail) {
    _instance.type = _instance.type || undefined;
    _instance.description = _instance.description || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AdditionalDetail,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.type = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.type,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.description = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.description,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AdditionalDetail.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AdditionalDetail,
    _writer: BinaryWriter
  ) {
    if (_instance.type) {
      _writer.writeMessage(
        1,
        _instance.type as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.description) {
      _writer.writeMessage(
        2,
        _instance.description as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _type?: googleProtobuf001.StringValue;
  private _description?: googleProtobuf001.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AdditionalDetail to deeply clone from
   */
  constructor(_value?: RecursivePartial<AdditionalDetail.AsObject>) {
    _value = _value || {};
    this.type = _value.type
      ? new googleProtobuf001.StringValue(_value.type)
      : undefined;
    this.description = _value.description
      ? new googleProtobuf001.StringValue(_value.description)
      : undefined;
    AdditionalDetail.refineValues(this);
  }
  get type(): googleProtobuf001.StringValue | undefined {
    return this._type;
  }
  set type(value: googleProtobuf001.StringValue | undefined) {
    this._type = value;
  }
  get description(): googleProtobuf001.StringValue | undefined {
    return this._description;
  }
  set description(value: googleProtobuf001.StringValue | undefined) {
    this._description = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AdditionalDetail.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AdditionalDetail.AsObject {
    return {
      type: this.type ? this.type.toObject() : undefined,
      description: this.description ? this.description.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AdditionalDetail.AsProtobufJSON {
    return {
      type: this.type ? this.type.toProtobufJSON(options) : null,
      description: this.description
        ? this.description.toProtobufJSON(options)
        : null
    };
  }
}
export module AdditionalDetail {
  /**
   * Standard JavaScript object representation for AdditionalDetail
   */
  export interface AsObject {
    type?: googleProtobuf001.StringValue.AsObject;
    description?: googleProtobuf001.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for AdditionalDetail
   */
  export interface AsProtobufJSON {
    type: googleProtobuf001.StringValue.AsProtobufJSON | null;
    description: googleProtobuf001.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.Image
 */
export class Image implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.Image';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Image();
    Image.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Image) {
    _instance.imageUrl = _instance.imageUrl || undefined;
    _instance.caption = _instance.caption || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Image, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.imageUrl = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.imageUrl,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.caption = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.caption,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    Image.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Image, _writer: BinaryWriter) {
    if (_instance.imageUrl) {
      _writer.writeMessage(
        1,
        _instance.imageUrl as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.caption) {
      _writer.writeMessage(
        2,
        _instance.caption as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _imageUrl?: googleProtobuf001.StringValue;
  private _caption?: googleProtobuf001.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Image to deeply clone from
   */
  constructor(_value?: RecursivePartial<Image.AsObject>) {
    _value = _value || {};
    this.imageUrl = _value.imageUrl
      ? new googleProtobuf001.StringValue(_value.imageUrl)
      : undefined;
    this.caption = _value.caption
      ? new googleProtobuf001.StringValue(_value.caption)
      : undefined;
    Image.refineValues(this);
  }
  get imageUrl(): googleProtobuf001.StringValue | undefined {
    return this._imageUrl;
  }
  set imageUrl(value: googleProtobuf001.StringValue | undefined) {
    this._imageUrl = value;
  }
  get caption(): googleProtobuf001.StringValue | undefined {
    return this._caption;
  }
  set caption(value: googleProtobuf001.StringValue | undefined) {
    this._caption = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Image.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Image.AsObject {
    return {
      imageUrl: this.imageUrl ? this.imageUrl.toObject() : undefined,
      caption: this.caption ? this.caption.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Image.AsProtobufJSON {
    return {
      imageUrl: this.imageUrl ? this.imageUrl.toProtobufJSON(options) : null,
      caption: this.caption ? this.caption.toProtobufJSON(options) : null
    };
  }
}
export module Image {
  /**
   * Standard JavaScript object representation for Image
   */
  export interface AsObject {
    imageUrl?: googleProtobuf001.StringValue.AsObject;
    caption?: googleProtobuf001.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for Image
   */
  export interface AsProtobufJSON {
    imageUrl: googleProtobuf001.StringValue.AsProtobufJSON | null;
    caption: googleProtobuf001.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AttractionDetailItinerary
 */
export class AttractionDetailItinerary implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AttractionDetailItinerary';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttractionDetailItinerary();
    AttractionDetailItinerary.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttractionDetailItinerary) {
    _instance.itineraryType = _instance.itineraryType || undefined;
    _instance.itineraryDescription =
      _instance.itineraryDescription || undefined;
    _instance.itineraryItems = _instance.itineraryItems || [];
    _instance.itineraryRoutes = _instance.itineraryRoutes || [];
    _instance.itineraryDays = _instance.itineraryDays || [];
    _instance.isPrivateTour = _instance.isPrivateTour || false;
    _instance.isSkipTheLine = _instance.isSkipTheLine || false;
    _instance.itineraryActivityInfo =
      _instance.itineraryActivityInfo || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttractionDetailItinerary,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itineraryType = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.itineraryType,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.itineraryDescription = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.itineraryDescription,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          const messageInitializer3 = new ItineraryItem();
          _reader.readMessage(
            messageInitializer3,
            ItineraryItem.deserializeBinaryFromReader
          );
          (_instance.itineraryItems = _instance.itineraryItems || []).push(
            messageInitializer3
          );
          break;
        case 4:
          const messageInitializer4 = new ItineraryRoute();
          _reader.readMessage(
            messageInitializer4,
            ItineraryRoute.deserializeBinaryFromReader
          );
          (_instance.itineraryRoutes = _instance.itineraryRoutes || []).push(
            messageInitializer4
          );
          break;
        case 5:
          const messageInitializer5 = new ItineraryDay();
          _reader.readMessage(
            messageInitializer5,
            ItineraryDay.deserializeBinaryFromReader
          );
          (_instance.itineraryDays = _instance.itineraryDays || []).push(
            messageInitializer5
          );
          break;
        case 6:
          _instance.isPrivateTour = _reader.readBool();
          break;
        case 7:
          _instance.isSkipTheLine = _reader.readBool();
          break;
        case 8:
          _instance.itineraryActivityInfo = new ItineraryActivityInfo();
          _reader.readMessage(
            _instance.itineraryActivityInfo,
            ItineraryActivityInfo.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AttractionDetailItinerary.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttractionDetailItinerary,
    _writer: BinaryWriter
  ) {
    if (_instance.itineraryType) {
      _writer.writeMessage(
        1,
        _instance.itineraryType as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.itineraryDescription) {
      _writer.writeMessage(
        2,
        _instance.itineraryDescription as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.itineraryItems && _instance.itineraryItems.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.itineraryItems as any,
        ItineraryItem.serializeBinaryToWriter
      );
    }
    if (_instance.itineraryRoutes && _instance.itineraryRoutes.length) {
      _writer.writeRepeatedMessage(
        4,
        _instance.itineraryRoutes as any,
        ItineraryRoute.serializeBinaryToWriter
      );
    }
    if (_instance.itineraryDays && _instance.itineraryDays.length) {
      _writer.writeRepeatedMessage(
        5,
        _instance.itineraryDays as any,
        ItineraryDay.serializeBinaryToWriter
      );
    }
    if (_instance.isPrivateTour) {
      _writer.writeBool(6, _instance.isPrivateTour);
    }
    if (_instance.isSkipTheLine) {
      _writer.writeBool(7, _instance.isSkipTheLine);
    }
    if (_instance.itineraryActivityInfo) {
      _writer.writeMessage(
        8,
        _instance.itineraryActivityInfo as any,
        ItineraryActivityInfo.serializeBinaryToWriter
      );
    }
  }

  private _itineraryType?: googleProtobuf001.StringValue;
  private _itineraryDescription?: googleProtobuf001.StringValue;
  private _itineraryItems?: ItineraryItem[];
  private _itineraryRoutes?: ItineraryRoute[];
  private _itineraryDays?: ItineraryDay[];
  private _isPrivateTour: boolean;
  private _isSkipTheLine: boolean;
  private _itineraryActivityInfo?: ItineraryActivityInfo;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttractionDetailItinerary to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttractionDetailItinerary.AsObject>) {
    _value = _value || {};
    this.itineraryType = _value.itineraryType
      ? new googleProtobuf001.StringValue(_value.itineraryType)
      : undefined;
    this.itineraryDescription = _value.itineraryDescription
      ? new googleProtobuf001.StringValue(_value.itineraryDescription)
      : undefined;
    this.itineraryItems = (_value.itineraryItems || []).map(
      m => new ItineraryItem(m)
    );
    this.itineraryRoutes = (_value.itineraryRoutes || []).map(
      m => new ItineraryRoute(m)
    );
    this.itineraryDays = (_value.itineraryDays || []).map(
      m => new ItineraryDay(m)
    );
    this.isPrivateTour = _value.isPrivateTour;
    this.isSkipTheLine = _value.isSkipTheLine;
    this.itineraryActivityInfo = _value.itineraryActivityInfo
      ? new ItineraryActivityInfo(_value.itineraryActivityInfo)
      : undefined;
    AttractionDetailItinerary.refineValues(this);
  }
  get itineraryType(): googleProtobuf001.StringValue | undefined {
    return this._itineraryType;
  }
  set itineraryType(value: googleProtobuf001.StringValue | undefined) {
    this._itineraryType = value;
  }
  get itineraryDescription(): googleProtobuf001.StringValue | undefined {
    return this._itineraryDescription;
  }
  set itineraryDescription(value: googleProtobuf001.StringValue | undefined) {
    this._itineraryDescription = value;
  }
  get itineraryItems(): ItineraryItem[] | undefined {
    return this._itineraryItems;
  }
  set itineraryItems(value: ItineraryItem[] | undefined) {
    this._itineraryItems = value;
  }
  get itineraryRoutes(): ItineraryRoute[] | undefined {
    return this._itineraryRoutes;
  }
  set itineraryRoutes(value: ItineraryRoute[] | undefined) {
    this._itineraryRoutes = value;
  }
  get itineraryDays(): ItineraryDay[] | undefined {
    return this._itineraryDays;
  }
  set itineraryDays(value: ItineraryDay[] | undefined) {
    this._itineraryDays = value;
  }
  get isPrivateTour(): boolean {
    return this._isPrivateTour;
  }
  set isPrivateTour(value: boolean) {
    this._isPrivateTour = value;
  }
  get isSkipTheLine(): boolean {
    return this._isSkipTheLine;
  }
  set isSkipTheLine(value: boolean) {
    this._isSkipTheLine = value;
  }
  get itineraryActivityInfo(): ItineraryActivityInfo | undefined {
    return this._itineraryActivityInfo;
  }
  set itineraryActivityInfo(value: ItineraryActivityInfo | undefined) {
    this._itineraryActivityInfo = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttractionDetailItinerary.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttractionDetailItinerary.AsObject {
    return {
      itineraryType: this.itineraryType
        ? this.itineraryType.toObject()
        : undefined,
      itineraryDescription: this.itineraryDescription
        ? this.itineraryDescription.toObject()
        : undefined,
      itineraryItems: (this.itineraryItems || []).map(m => m.toObject()),
      itineraryRoutes: (this.itineraryRoutes || []).map(m => m.toObject()),
      itineraryDays: (this.itineraryDays || []).map(m => m.toObject()),
      isPrivateTour: this.isPrivateTour,
      isSkipTheLine: this.isSkipTheLine,
      itineraryActivityInfo: this.itineraryActivityInfo
        ? this.itineraryActivityInfo.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttractionDetailItinerary.AsProtobufJSON {
    return {
      itineraryType: this.itineraryType
        ? this.itineraryType.toProtobufJSON(options)
        : null,
      itineraryDescription: this.itineraryDescription
        ? this.itineraryDescription.toProtobufJSON(options)
        : null,
      itineraryItems: (this.itineraryItems || []).map(m =>
        m.toProtobufJSON(options)
      ),
      itineraryRoutes: (this.itineraryRoutes || []).map(m =>
        m.toProtobufJSON(options)
      ),
      itineraryDays: (this.itineraryDays || []).map(m =>
        m.toProtobufJSON(options)
      ),
      isPrivateTour: this.isPrivateTour,
      isSkipTheLine: this.isSkipTheLine,
      itineraryActivityInfo: this.itineraryActivityInfo
        ? this.itineraryActivityInfo.toProtobufJSON(options)
        : null
    };
  }
}
export module AttractionDetailItinerary {
  /**
   * Standard JavaScript object representation for AttractionDetailItinerary
   */
  export interface AsObject {
    itineraryType?: googleProtobuf001.StringValue.AsObject;
    itineraryDescription?: googleProtobuf001.StringValue.AsObject;
    itineraryItems?: ItineraryItem.AsObject[];
    itineraryRoutes?: ItineraryRoute.AsObject[];
    itineraryDays?: ItineraryDay.AsObject[];
    isPrivateTour: boolean;
    isSkipTheLine: boolean;
    itineraryActivityInfo?: ItineraryActivityInfo.AsObject;
  }

  /**
   * Protobuf JSON representation for AttractionDetailItinerary
   */
  export interface AsProtobufJSON {
    itineraryType: googleProtobuf001.StringValue.AsProtobufJSON | null;
    itineraryDescription: googleProtobuf001.StringValue.AsProtobufJSON | null;
    itineraryItems: ItineraryItem.AsProtobufJSON[] | null;
    itineraryRoutes: ItineraryRoute.AsProtobufJSON[] | null;
    itineraryDays: ItineraryDay.AsProtobufJSON[] | null;
    isPrivateTour: boolean;
    isSkipTheLine: boolean;
    itineraryActivityInfo: ItineraryActivityInfo.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.ItineraryActivityInfo
 */
export class ItineraryActivityInfo implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.ItineraryActivityInfo';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItineraryActivityInfo();
    ItineraryActivityInfo.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItineraryActivityInfo) {
    _instance.description = _instance.description || undefined;
    _instance.foodMenus = _instance.foodMenus || [];
    _instance.activityLocation = _instance.activityLocation || undefined;
    _instance.pointOfInterestLocations =
      _instance.pointOfInterestLocations || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItineraryActivityInfo,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.description = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.description,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          const messageInitializer2 = new FoodMenu();
          _reader.readMessage(
            messageInitializer2,
            FoodMenu.deserializeBinaryFromReader
          );
          (_instance.foodMenus = _instance.foodMenus || []).push(
            messageInitializer2
          );
          break;
        case 3:
          _instance.activityLocation = new Location();
          _reader.readMessage(
            _instance.activityLocation,
            Location.deserializeBinaryFromReader
          );
          break;
        case 4:
          const messageInitializer4 = new Location();
          _reader.readMessage(
            messageInitializer4,
            Location.deserializeBinaryFromReader
          );
          (_instance.pointOfInterestLocations =
            _instance.pointOfInterestLocations || []).push(messageInitializer4);
          break;
        default:
          _reader.skipField();
      }
    }

    ItineraryActivityInfo.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItineraryActivityInfo,
    _writer: BinaryWriter
  ) {
    if (_instance.description) {
      _writer.writeMessage(
        1,
        _instance.description as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.foodMenus && _instance.foodMenus.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.foodMenus as any,
        FoodMenu.serializeBinaryToWriter
      );
    }
    if (_instance.activityLocation) {
      _writer.writeMessage(
        3,
        _instance.activityLocation as any,
        Location.serializeBinaryToWriter
      );
    }
    if (
      _instance.pointOfInterestLocations &&
      _instance.pointOfInterestLocations.length
    ) {
      _writer.writeRepeatedMessage(
        4,
        _instance.pointOfInterestLocations as any,
        Location.serializeBinaryToWriter
      );
    }
  }

  private _description?: googleProtobuf001.StringValue;
  private _foodMenus?: FoodMenu[];
  private _activityLocation?: Location;
  private _pointOfInterestLocations?: Location[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItineraryActivityInfo to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItineraryActivityInfo.AsObject>) {
    _value = _value || {};
    this.description = _value.description
      ? new googleProtobuf001.StringValue(_value.description)
      : undefined;
    this.foodMenus = (_value.foodMenus || []).map(m => new FoodMenu(m));
    this.activityLocation = _value.activityLocation
      ? new Location(_value.activityLocation)
      : undefined;
    this.pointOfInterestLocations = (_value.pointOfInterestLocations || []).map(
      m => new Location(m)
    );
    ItineraryActivityInfo.refineValues(this);
  }
  get description(): googleProtobuf001.StringValue | undefined {
    return this._description;
  }
  set description(value: googleProtobuf001.StringValue | undefined) {
    this._description = value;
  }
  get foodMenus(): FoodMenu[] | undefined {
    return this._foodMenus;
  }
  set foodMenus(value: FoodMenu[] | undefined) {
    this._foodMenus = value;
  }
  get activityLocation(): Location | undefined {
    return this._activityLocation;
  }
  set activityLocation(value: Location | undefined) {
    this._activityLocation = value;
  }
  get pointOfInterestLocations(): Location[] | undefined {
    return this._pointOfInterestLocations;
  }
  set pointOfInterestLocations(value: Location[] | undefined) {
    this._pointOfInterestLocations = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItineraryActivityInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItineraryActivityInfo.AsObject {
    return {
      description: this.description ? this.description.toObject() : undefined,
      foodMenus: (this.foodMenus || []).map(m => m.toObject()),
      activityLocation: this.activityLocation
        ? this.activityLocation.toObject()
        : undefined,
      pointOfInterestLocations: (this.pointOfInterestLocations || []).map(m =>
        m.toObject()
      )
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItineraryActivityInfo.AsProtobufJSON {
    return {
      description: this.description
        ? this.description.toProtobufJSON(options)
        : null,
      foodMenus: (this.foodMenus || []).map(m => m.toProtobufJSON(options)),
      activityLocation: this.activityLocation
        ? this.activityLocation.toProtobufJSON(options)
        : null,
      pointOfInterestLocations: (this.pointOfInterestLocations || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module ItineraryActivityInfo {
  /**
   * Standard JavaScript object representation for ItineraryActivityInfo
   */
  export interface AsObject {
    description?: googleProtobuf001.StringValue.AsObject;
    foodMenus?: FoodMenu.AsObject[];
    activityLocation?: Location.AsObject;
    pointOfInterestLocations?: Location.AsObject[];
  }

  /**
   * Protobuf JSON representation for ItineraryActivityInfo
   */
  export interface AsProtobufJSON {
    description: googleProtobuf001.StringValue.AsProtobufJSON | null;
    foodMenus: FoodMenu.AsProtobufJSON[] | null;
    activityLocation: Location.AsProtobufJSON | null;
    pointOfInterestLocations: Location.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.FoodMenu
 */
export class FoodMenu implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.FoodMenu';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new FoodMenu();
    FoodMenu.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: FoodMenu) {
    _instance.course = _instance.course || undefined;
    _instance.dishName = _instance.dishName || undefined;
    _instance.dishDescription = _instance.dishDescription || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: FoodMenu,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.course = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.course,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.dishName = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.dishName,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.dishDescription = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.dishDescription,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    FoodMenu.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: FoodMenu, _writer: BinaryWriter) {
    if (_instance.course) {
      _writer.writeMessage(
        1,
        _instance.course as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.dishName) {
      _writer.writeMessage(
        2,
        _instance.dishName as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.dishDescription) {
      _writer.writeMessage(
        3,
        _instance.dishDescription as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _course?: googleProtobuf001.StringValue;
  private _dishName?: googleProtobuf001.StringValue;
  private _dishDescription?: googleProtobuf001.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of FoodMenu to deeply clone from
   */
  constructor(_value?: RecursivePartial<FoodMenu.AsObject>) {
    _value = _value || {};
    this.course = _value.course
      ? new googleProtobuf001.StringValue(_value.course)
      : undefined;
    this.dishName = _value.dishName
      ? new googleProtobuf001.StringValue(_value.dishName)
      : undefined;
    this.dishDescription = _value.dishDescription
      ? new googleProtobuf001.StringValue(_value.dishDescription)
      : undefined;
    FoodMenu.refineValues(this);
  }
  get course(): googleProtobuf001.StringValue | undefined {
    return this._course;
  }
  set course(value: googleProtobuf001.StringValue | undefined) {
    this._course = value;
  }
  get dishName(): googleProtobuf001.StringValue | undefined {
    return this._dishName;
  }
  set dishName(value: googleProtobuf001.StringValue | undefined) {
    this._dishName = value;
  }
  get dishDescription(): googleProtobuf001.StringValue | undefined {
    return this._dishDescription;
  }
  set dishDescription(value: googleProtobuf001.StringValue | undefined) {
    this._dishDescription = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    FoodMenu.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): FoodMenu.AsObject {
    return {
      course: this.course ? this.course.toObject() : undefined,
      dishName: this.dishName ? this.dishName.toObject() : undefined,
      dishDescription: this.dishDescription
        ? this.dishDescription.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): FoodMenu.AsProtobufJSON {
    return {
      course: this.course ? this.course.toProtobufJSON(options) : null,
      dishName: this.dishName ? this.dishName.toProtobufJSON(options) : null,
      dishDescription: this.dishDescription
        ? this.dishDescription.toProtobufJSON(options)
        : null
    };
  }
}
export module FoodMenu {
  /**
   * Standard JavaScript object representation for FoodMenu
   */
  export interface AsObject {
    course?: googleProtobuf001.StringValue.AsObject;
    dishName?: googleProtobuf001.StringValue.AsObject;
    dishDescription?: googleProtobuf001.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for FoodMenu
   */
  export interface AsProtobufJSON {
    course: googleProtobuf001.StringValue.AsProtobufJSON | null;
    dishName: googleProtobuf001.StringValue.AsProtobufJSON | null;
    dishDescription: googleProtobuf001.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.ItineraryDay
 */
export class ItineraryDay implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.ItineraryDay';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItineraryDay();
    ItineraryDay.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItineraryDay) {
    _instance.dayNumber = _instance.dayNumber || 0;
    _instance.title = _instance.title || undefined;
    _instance.accommodations = _instance.accommodations || [];
    _instance.foodAndDrinks = _instance.foodAndDrinks || [];
    _instance.itineraryItems = _instance.itineraryItems || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItineraryDay,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.dayNumber = _reader.readInt32();
          break;
        case 2:
          _instance.title = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.title,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          (_instance.accommodations = _instance.accommodations || []).push(
            _reader.readString()
          );
          break;
        case 4:
          const messageInitializer4 = new FoodAndDrink();
          _reader.readMessage(
            messageInitializer4,
            FoodAndDrink.deserializeBinaryFromReader
          );
          (_instance.foodAndDrinks = _instance.foodAndDrinks || []).push(
            messageInitializer4
          );
          break;
        case 5:
          const messageInitializer5 = new ItineraryItem();
          _reader.readMessage(
            messageInitializer5,
            ItineraryItem.deserializeBinaryFromReader
          );
          (_instance.itineraryItems = _instance.itineraryItems || []).push(
            messageInitializer5
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItineraryDay.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItineraryDay,
    _writer: BinaryWriter
  ) {
    if (_instance.dayNumber) {
      _writer.writeInt32(1, _instance.dayNumber);
    }
    if (_instance.title) {
      _writer.writeMessage(
        2,
        _instance.title as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.accommodations && _instance.accommodations.length) {
      _writer.writeRepeatedString(3, _instance.accommodations);
    }
    if (_instance.foodAndDrinks && _instance.foodAndDrinks.length) {
      _writer.writeRepeatedMessage(
        4,
        _instance.foodAndDrinks as any,
        FoodAndDrink.serializeBinaryToWriter
      );
    }
    if (_instance.itineraryItems && _instance.itineraryItems.length) {
      _writer.writeRepeatedMessage(
        5,
        _instance.itineraryItems as any,
        ItineraryItem.serializeBinaryToWriter
      );
    }
  }

  private _dayNumber: number;
  private _title?: googleProtobuf001.StringValue;
  private _accommodations: string[];
  private _foodAndDrinks?: FoodAndDrink[];
  private _itineraryItems?: ItineraryItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItineraryDay to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItineraryDay.AsObject>) {
    _value = _value || {};
    this.dayNumber = _value.dayNumber;
    this.title = _value.title
      ? new googleProtobuf001.StringValue(_value.title)
      : undefined;
    this.accommodations = (_value.accommodations || []).slice();
    this.foodAndDrinks = (_value.foodAndDrinks || []).map(
      m => new FoodAndDrink(m)
    );
    this.itineraryItems = (_value.itineraryItems || []).map(
      m => new ItineraryItem(m)
    );
    ItineraryDay.refineValues(this);
  }
  get dayNumber(): number {
    return this._dayNumber;
  }
  set dayNumber(value: number) {
    this._dayNumber = value;
  }
  get title(): googleProtobuf001.StringValue | undefined {
    return this._title;
  }
  set title(value: googleProtobuf001.StringValue | undefined) {
    this._title = value;
  }
  get accommodations(): string[] {
    return this._accommodations;
  }
  set accommodations(value: string[]) {
    this._accommodations = value;
  }
  get foodAndDrinks(): FoodAndDrink[] | undefined {
    return this._foodAndDrinks;
  }
  set foodAndDrinks(value: FoodAndDrink[] | undefined) {
    this._foodAndDrinks = value;
  }
  get itineraryItems(): ItineraryItem[] | undefined {
    return this._itineraryItems;
  }
  set itineraryItems(value: ItineraryItem[] | undefined) {
    this._itineraryItems = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItineraryDay.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItineraryDay.AsObject {
    return {
      dayNumber: this.dayNumber,
      title: this.title ? this.title.toObject() : undefined,
      accommodations: (this.accommodations || []).slice(),
      foodAndDrinks: (this.foodAndDrinks || []).map(m => m.toObject()),
      itineraryItems: (this.itineraryItems || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItineraryDay.AsProtobufJSON {
    return {
      dayNumber: this.dayNumber,
      title: this.title ? this.title.toProtobufJSON(options) : null,
      accommodations: (this.accommodations || []).slice(),
      foodAndDrinks: (this.foodAndDrinks || []).map(m =>
        m.toProtobufJSON(options)
      ),
      itineraryItems: (this.itineraryItems || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module ItineraryDay {
  /**
   * Standard JavaScript object representation for ItineraryDay
   */
  export interface AsObject {
    dayNumber: number;
    title?: googleProtobuf001.StringValue.AsObject;
    accommodations: string[];
    foodAndDrinks?: FoodAndDrink.AsObject[];
    itineraryItems?: ItineraryItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for ItineraryDay
   */
  export interface AsProtobufJSON {
    dayNumber: number;
    title: googleProtobuf001.StringValue.AsProtobufJSON | null;
    accommodations: string[];
    foodAndDrinks: FoodAndDrink.AsProtobufJSON[] | null;
    itineraryItems: ItineraryItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.FoodAndDrink
 */
export class FoodAndDrink implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.FoodAndDrink';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new FoodAndDrink();
    FoodAndDrink.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: FoodAndDrink) {
    _instance.type = _instance.type || undefined;
    _instance.typeDescription = _instance.typeDescription || undefined;
    _instance.description = _instance.description || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: FoodAndDrink,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.type = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.type,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.typeDescription = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.typeDescription,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.description = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.description,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    FoodAndDrink.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: FoodAndDrink,
    _writer: BinaryWriter
  ) {
    if (_instance.type) {
      _writer.writeMessage(
        1,
        _instance.type as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.typeDescription) {
      _writer.writeMessage(
        2,
        _instance.typeDescription as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.description) {
      _writer.writeMessage(
        3,
        _instance.description as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _type?: googleProtobuf001.StringValue;
  private _typeDescription?: googleProtobuf001.StringValue;
  private _description?: googleProtobuf001.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of FoodAndDrink to deeply clone from
   */
  constructor(_value?: RecursivePartial<FoodAndDrink.AsObject>) {
    _value = _value || {};
    this.type = _value.type
      ? new googleProtobuf001.StringValue(_value.type)
      : undefined;
    this.typeDescription = _value.typeDescription
      ? new googleProtobuf001.StringValue(_value.typeDescription)
      : undefined;
    this.description = _value.description
      ? new googleProtobuf001.StringValue(_value.description)
      : undefined;
    FoodAndDrink.refineValues(this);
  }
  get type(): googleProtobuf001.StringValue | undefined {
    return this._type;
  }
  set type(value: googleProtobuf001.StringValue | undefined) {
    this._type = value;
  }
  get typeDescription(): googleProtobuf001.StringValue | undefined {
    return this._typeDescription;
  }
  set typeDescription(value: googleProtobuf001.StringValue | undefined) {
    this._typeDescription = value;
  }
  get description(): googleProtobuf001.StringValue | undefined {
    return this._description;
  }
  set description(value: googleProtobuf001.StringValue | undefined) {
    this._description = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    FoodAndDrink.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): FoodAndDrink.AsObject {
    return {
      type: this.type ? this.type.toObject() : undefined,
      typeDescription: this.typeDescription
        ? this.typeDescription.toObject()
        : undefined,
      description: this.description ? this.description.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): FoodAndDrink.AsProtobufJSON {
    return {
      type: this.type ? this.type.toProtobufJSON(options) : null,
      typeDescription: this.typeDescription
        ? this.typeDescription.toProtobufJSON(options)
        : null,
      description: this.description
        ? this.description.toProtobufJSON(options)
        : null
    };
  }
}
export module FoodAndDrink {
  /**
   * Standard JavaScript object representation for FoodAndDrink
   */
  export interface AsObject {
    type?: googleProtobuf001.StringValue.AsObject;
    typeDescription?: googleProtobuf001.StringValue.AsObject;
    description?: googleProtobuf001.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for FoodAndDrink
   */
  export interface AsProtobufJSON {
    type: googleProtobuf001.StringValue.AsProtobufJSON | null;
    typeDescription: googleProtobuf001.StringValue.AsProtobufJSON | null;
    description: googleProtobuf001.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.ItineraryItem
 */
export class ItineraryItem implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.ItineraryItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItineraryItem();
    ItineraryItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItineraryItem) {
    _instance.isPassByWithoutStopping =
      _instance.isPassByWithoutStopping || false;
    _instance.admissionIncluded = _instance.admissionIncluded || undefined;
    _instance.description = _instance.description || undefined;
    _instance.pointOfInterestLocation =
      _instance.pointOfInterestLocation || undefined;
    _instance.durationFromMinutes = _instance.durationFromMinutes || undefined;
    _instance.durationToMinutes = _instance.durationToMinutes || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItineraryItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.isPassByWithoutStopping = _reader.readBool();
          break;
        case 2:
          _instance.admissionIncluded = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.admissionIncluded,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.description = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.description,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.pointOfInterestLocation = new Location();
          _reader.readMessage(
            _instance.pointOfInterestLocation,
            Location.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.durationFromMinutes = new googleProtobuf001.Int32Value();
          _reader.readMessage(
            _instance.durationFromMinutes,
            googleProtobuf001.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.durationToMinutes = new googleProtobuf001.Int32Value();
          _reader.readMessage(
            _instance.durationToMinutes,
            googleProtobuf001.Int32Value.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItineraryItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItineraryItem,
    _writer: BinaryWriter
  ) {
    if (_instance.isPassByWithoutStopping) {
      _writer.writeBool(1, _instance.isPassByWithoutStopping);
    }
    if (_instance.admissionIncluded) {
      _writer.writeMessage(
        2,
        _instance.admissionIncluded as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.description) {
      _writer.writeMessage(
        3,
        _instance.description as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.pointOfInterestLocation) {
      _writer.writeMessage(
        4,
        _instance.pointOfInterestLocation as any,
        Location.serializeBinaryToWriter
      );
    }
    if (_instance.durationFromMinutes) {
      _writer.writeMessage(
        5,
        _instance.durationFromMinutes as any,
        googleProtobuf001.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.durationToMinutes) {
      _writer.writeMessage(
        6,
        _instance.durationToMinutes as any,
        googleProtobuf001.Int32Value.serializeBinaryToWriter
      );
    }
  }

  private _isPassByWithoutStopping: boolean;
  private _admissionIncluded?: googleProtobuf001.StringValue;
  private _description?: googleProtobuf001.StringValue;
  private _pointOfInterestLocation?: Location;
  private _durationFromMinutes?: googleProtobuf001.Int32Value;
  private _durationToMinutes?: googleProtobuf001.Int32Value;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItineraryItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItineraryItem.AsObject>) {
    _value = _value || {};
    this.isPassByWithoutStopping = _value.isPassByWithoutStopping;
    this.admissionIncluded = _value.admissionIncluded
      ? new googleProtobuf001.StringValue(_value.admissionIncluded)
      : undefined;
    this.description = _value.description
      ? new googleProtobuf001.StringValue(_value.description)
      : undefined;
    this.pointOfInterestLocation = _value.pointOfInterestLocation
      ? new Location(_value.pointOfInterestLocation)
      : undefined;
    this.durationFromMinutes = _value.durationFromMinutes
      ? new googleProtobuf001.Int32Value(_value.durationFromMinutes)
      : undefined;
    this.durationToMinutes = _value.durationToMinutes
      ? new googleProtobuf001.Int32Value(_value.durationToMinutes)
      : undefined;
    ItineraryItem.refineValues(this);
  }
  get isPassByWithoutStopping(): boolean {
    return this._isPassByWithoutStopping;
  }
  set isPassByWithoutStopping(value: boolean) {
    this._isPassByWithoutStopping = value;
  }
  get admissionIncluded(): googleProtobuf001.StringValue | undefined {
    return this._admissionIncluded;
  }
  set admissionIncluded(value: googleProtobuf001.StringValue | undefined) {
    this._admissionIncluded = value;
  }
  get description(): googleProtobuf001.StringValue | undefined {
    return this._description;
  }
  set description(value: googleProtobuf001.StringValue | undefined) {
    this._description = value;
  }
  get pointOfInterestLocation(): Location | undefined {
    return this._pointOfInterestLocation;
  }
  set pointOfInterestLocation(value: Location | undefined) {
    this._pointOfInterestLocation = value;
  }
  get durationFromMinutes(): googleProtobuf001.Int32Value | undefined {
    return this._durationFromMinutes;
  }
  set durationFromMinutes(value: googleProtobuf001.Int32Value | undefined) {
    this._durationFromMinutes = value;
  }
  get durationToMinutes(): googleProtobuf001.Int32Value | undefined {
    return this._durationToMinutes;
  }
  set durationToMinutes(value: googleProtobuf001.Int32Value | undefined) {
    this._durationToMinutes = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItineraryItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItineraryItem.AsObject {
    return {
      isPassByWithoutStopping: this.isPassByWithoutStopping,
      admissionIncluded: this.admissionIncluded
        ? this.admissionIncluded.toObject()
        : undefined,
      description: this.description ? this.description.toObject() : undefined,
      pointOfInterestLocation: this.pointOfInterestLocation
        ? this.pointOfInterestLocation.toObject()
        : undefined,
      durationFromMinutes: this.durationFromMinutes
        ? this.durationFromMinutes.toObject()
        : undefined,
      durationToMinutes: this.durationToMinutes
        ? this.durationToMinutes.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItineraryItem.AsProtobufJSON {
    return {
      isPassByWithoutStopping: this.isPassByWithoutStopping,
      admissionIncluded: this.admissionIncluded
        ? this.admissionIncluded.toProtobufJSON(options)
        : null,
      description: this.description
        ? this.description.toProtobufJSON(options)
        : null,
      pointOfInterestLocation: this.pointOfInterestLocation
        ? this.pointOfInterestLocation.toProtobufJSON(options)
        : null,
      durationFromMinutes: this.durationFromMinutes
        ? this.durationFromMinutes.toProtobufJSON(options)
        : null,
      durationToMinutes: this.durationToMinutes
        ? this.durationToMinutes.toProtobufJSON(options)
        : null
    };
  }
}
export module ItineraryItem {
  /**
   * Standard JavaScript object representation for ItineraryItem
   */
  export interface AsObject {
    isPassByWithoutStopping: boolean;
    admissionIncluded?: googleProtobuf001.StringValue.AsObject;
    description?: googleProtobuf001.StringValue.AsObject;
    pointOfInterestLocation?: Location.AsObject;
    durationFromMinutes?: googleProtobuf001.Int32Value.AsObject;
    durationToMinutes?: googleProtobuf001.Int32Value.AsObject;
  }

  /**
   * Protobuf JSON representation for ItineraryItem
   */
  export interface AsProtobufJSON {
    isPassByWithoutStopping: boolean;
    admissionIncluded: googleProtobuf001.StringValue.AsProtobufJSON | null;
    description: googleProtobuf001.StringValue.AsProtobufJSON | null;
    pointOfInterestLocation: Location.AsProtobufJSON | null;
    durationFromMinutes: googleProtobuf001.Int32Value.AsProtobufJSON | null;
    durationToMinutes: googleProtobuf001.Int32Value.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.Location
 */
export class Location implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.Location';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Location();
    Location.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Location) {
    _instance.locationName = _instance.locationName || undefined;
    _instance.address = _instance.address || undefined;
    _instance.description = _instance.description || undefined;
    _instance.longitude = _instance.longitude || undefined;
    _instance.latitude = _instance.latitude || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Location,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.locationName = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.locationName,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.address = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.address,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.description = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.description,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.longitude = new googleType000.Decimal();
          _reader.readMessage(
            _instance.longitude,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.latitude = new googleType000.Decimal();
          _reader.readMessage(
            _instance.latitude,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    Location.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Location, _writer: BinaryWriter) {
    if (_instance.locationName) {
      _writer.writeMessage(
        1,
        _instance.locationName as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.address) {
      _writer.writeMessage(
        2,
        _instance.address as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.description) {
      _writer.writeMessage(
        3,
        _instance.description as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.longitude) {
      _writer.writeMessage(
        4,
        _instance.longitude as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.latitude) {
      _writer.writeMessage(
        5,
        _instance.latitude as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
  }

  private _locationName?: googleProtobuf001.StringValue;
  private _address?: googleProtobuf001.StringValue;
  private _description?: googleProtobuf001.StringValue;
  private _longitude?: googleType000.Decimal;
  private _latitude?: googleType000.Decimal;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Location to deeply clone from
   */
  constructor(_value?: RecursivePartial<Location.AsObject>) {
    _value = _value || {};
    this.locationName = _value.locationName
      ? new googleProtobuf001.StringValue(_value.locationName)
      : undefined;
    this.address = _value.address
      ? new googleProtobuf001.StringValue(_value.address)
      : undefined;
    this.description = _value.description
      ? new googleProtobuf001.StringValue(_value.description)
      : undefined;
    this.longitude = _value.longitude
      ? new googleType000.Decimal(_value.longitude)
      : undefined;
    this.latitude = _value.latitude
      ? new googleType000.Decimal(_value.latitude)
      : undefined;
    Location.refineValues(this);
  }
  get locationName(): googleProtobuf001.StringValue | undefined {
    return this._locationName;
  }
  set locationName(value: googleProtobuf001.StringValue | undefined) {
    this._locationName = value;
  }
  get address(): googleProtobuf001.StringValue | undefined {
    return this._address;
  }
  set address(value: googleProtobuf001.StringValue | undefined) {
    this._address = value;
  }
  get description(): googleProtobuf001.StringValue | undefined {
    return this._description;
  }
  set description(value: googleProtobuf001.StringValue | undefined) {
    this._description = value;
  }
  get longitude(): googleType000.Decimal | undefined {
    return this._longitude;
  }
  set longitude(value: googleType000.Decimal | undefined) {
    this._longitude = value;
  }
  get latitude(): googleType000.Decimal | undefined {
    return this._latitude;
  }
  set latitude(value: googleType000.Decimal | undefined) {
    this._latitude = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Location.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Location.AsObject {
    return {
      locationName: this.locationName
        ? this.locationName.toObject()
        : undefined,
      address: this.address ? this.address.toObject() : undefined,
      description: this.description ? this.description.toObject() : undefined,
      longitude: this.longitude ? this.longitude.toObject() : undefined,
      latitude: this.latitude ? this.latitude.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Location.AsProtobufJSON {
    return {
      locationName: this.locationName
        ? this.locationName.toProtobufJSON(options)
        : null,
      address: this.address ? this.address.toProtobufJSON(options) : null,
      description: this.description
        ? this.description.toProtobufJSON(options)
        : null,
      longitude: this.longitude ? this.longitude.toProtobufJSON(options) : null,
      latitude: this.latitude ? this.latitude.toProtobufJSON(options) : null
    };
  }
}
export module Location {
  /**
   * Standard JavaScript object representation for Location
   */
  export interface AsObject {
    locationName?: googleProtobuf001.StringValue.AsObject;
    address?: googleProtobuf001.StringValue.AsObject;
    description?: googleProtobuf001.StringValue.AsObject;
    longitude?: googleType000.Decimal.AsObject;
    latitude?: googleType000.Decimal.AsObject;
  }

  /**
   * Protobuf JSON representation for Location
   */
  export interface AsProtobufJSON {
    locationName: googleProtobuf001.StringValue.AsProtobufJSON | null;
    address: googleProtobuf001.StringValue.AsProtobufJSON | null;
    description: googleProtobuf001.StringValue.AsProtobufJSON | null;
    longitude: googleType000.Decimal.AsProtobufJSON | null;
    latitude: googleType000.Decimal.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.ItineraryRoute
 */
export class ItineraryRoute implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.ItineraryRoute';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItineraryRoute();
    ItineraryRoute.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItineraryRoute) {
    _instance.name = _instance.name || undefined;
    _instance.operatingSchedule = _instance.operatingSchedule || undefined;
    _instance.pointOfInterestLocations =
      _instance.pointOfInterestLocations || [];
    _instance.durationFromMinutes = _instance.durationFromMinutes || undefined;
    _instance.durationToMinutes = _instance.durationToMinutes || undefined;
    _instance.stopLocations = _instance.stopLocations || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItineraryRoute,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.name = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.name,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.operatingSchedule = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.operatingSchedule,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          const messageInitializer3 = new Location();
          _reader.readMessage(
            messageInitializer3,
            Location.deserializeBinaryFromReader
          );
          (_instance.pointOfInterestLocations =
            _instance.pointOfInterestLocations || []).push(messageInitializer3);
          break;
        case 4:
          _instance.durationFromMinutes = new googleProtobuf001.Int32Value();
          _reader.readMessage(
            _instance.durationFromMinutes,
            googleProtobuf001.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.durationToMinutes = new googleProtobuf001.Int32Value();
          _reader.readMessage(
            _instance.durationToMinutes,
            googleProtobuf001.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 6:
          const messageInitializer6 = new Location();
          _reader.readMessage(
            messageInitializer6,
            Location.deserializeBinaryFromReader
          );
          (_instance.stopLocations = _instance.stopLocations || []).push(
            messageInitializer6
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItineraryRoute.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItineraryRoute,
    _writer: BinaryWriter
  ) {
    if (_instance.name) {
      _writer.writeMessage(
        1,
        _instance.name as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.operatingSchedule) {
      _writer.writeMessage(
        2,
        _instance.operatingSchedule as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (
      _instance.pointOfInterestLocations &&
      _instance.pointOfInterestLocations.length
    ) {
      _writer.writeRepeatedMessage(
        3,
        _instance.pointOfInterestLocations as any,
        Location.serializeBinaryToWriter
      );
    }
    if (_instance.durationFromMinutes) {
      _writer.writeMessage(
        4,
        _instance.durationFromMinutes as any,
        googleProtobuf001.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.durationToMinutes) {
      _writer.writeMessage(
        5,
        _instance.durationToMinutes as any,
        googleProtobuf001.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.stopLocations && _instance.stopLocations.length) {
      _writer.writeRepeatedMessage(
        6,
        _instance.stopLocations as any,
        Location.serializeBinaryToWriter
      );
    }
  }

  private _name?: googleProtobuf001.StringValue;
  private _operatingSchedule?: googleProtobuf001.StringValue;
  private _pointOfInterestLocations?: Location[];
  private _durationFromMinutes?: googleProtobuf001.Int32Value;
  private _durationToMinutes?: googleProtobuf001.Int32Value;
  private _stopLocations?: Location[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItineraryRoute to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItineraryRoute.AsObject>) {
    _value = _value || {};
    this.name = _value.name
      ? new googleProtobuf001.StringValue(_value.name)
      : undefined;
    this.operatingSchedule = _value.operatingSchedule
      ? new googleProtobuf001.StringValue(_value.operatingSchedule)
      : undefined;
    this.pointOfInterestLocations = (_value.pointOfInterestLocations || []).map(
      m => new Location(m)
    );
    this.durationFromMinutes = _value.durationFromMinutes
      ? new googleProtobuf001.Int32Value(_value.durationFromMinutes)
      : undefined;
    this.durationToMinutes = _value.durationToMinutes
      ? new googleProtobuf001.Int32Value(_value.durationToMinutes)
      : undefined;
    this.stopLocations = (_value.stopLocations || []).map(m => new Location(m));
    ItineraryRoute.refineValues(this);
  }
  get name(): googleProtobuf001.StringValue | undefined {
    return this._name;
  }
  set name(value: googleProtobuf001.StringValue | undefined) {
    this._name = value;
  }
  get operatingSchedule(): googleProtobuf001.StringValue | undefined {
    return this._operatingSchedule;
  }
  set operatingSchedule(value: googleProtobuf001.StringValue | undefined) {
    this._operatingSchedule = value;
  }
  get pointOfInterestLocations(): Location[] | undefined {
    return this._pointOfInterestLocations;
  }
  set pointOfInterestLocations(value: Location[] | undefined) {
    this._pointOfInterestLocations = value;
  }
  get durationFromMinutes(): googleProtobuf001.Int32Value | undefined {
    return this._durationFromMinutes;
  }
  set durationFromMinutes(value: googleProtobuf001.Int32Value | undefined) {
    this._durationFromMinutes = value;
  }
  get durationToMinutes(): googleProtobuf001.Int32Value | undefined {
    return this._durationToMinutes;
  }
  set durationToMinutes(value: googleProtobuf001.Int32Value | undefined) {
    this._durationToMinutes = value;
  }
  get stopLocations(): Location[] | undefined {
    return this._stopLocations;
  }
  set stopLocations(value: Location[] | undefined) {
    this._stopLocations = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItineraryRoute.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItineraryRoute.AsObject {
    return {
      name: this.name ? this.name.toObject() : undefined,
      operatingSchedule: this.operatingSchedule
        ? this.operatingSchedule.toObject()
        : undefined,
      pointOfInterestLocations: (this.pointOfInterestLocations || []).map(m =>
        m.toObject()
      ),
      durationFromMinutes: this.durationFromMinutes
        ? this.durationFromMinutes.toObject()
        : undefined,
      durationToMinutes: this.durationToMinutes
        ? this.durationToMinutes.toObject()
        : undefined,
      stopLocations: (this.stopLocations || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItineraryRoute.AsProtobufJSON {
    return {
      name: this.name ? this.name.toProtobufJSON(options) : null,
      operatingSchedule: this.operatingSchedule
        ? this.operatingSchedule.toProtobufJSON(options)
        : null,
      pointOfInterestLocations: (this.pointOfInterestLocations || []).map(m =>
        m.toProtobufJSON(options)
      ),
      durationFromMinutes: this.durationFromMinutes
        ? this.durationFromMinutes.toProtobufJSON(options)
        : null,
      durationToMinutes: this.durationToMinutes
        ? this.durationToMinutes.toProtobufJSON(options)
        : null,
      stopLocations: (this.stopLocations || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module ItineraryRoute {
  /**
   * Standard JavaScript object representation for ItineraryRoute
   */
  export interface AsObject {
    name?: googleProtobuf001.StringValue.AsObject;
    operatingSchedule?: googleProtobuf001.StringValue.AsObject;
    pointOfInterestLocations?: Location.AsObject[];
    durationFromMinutes?: googleProtobuf001.Int32Value.AsObject;
    durationToMinutes?: googleProtobuf001.Int32Value.AsObject;
    stopLocations?: Location.AsObject[];
  }

  /**
   * Protobuf JSON representation for ItineraryRoute
   */
  export interface AsProtobufJSON {
    name: googleProtobuf001.StringValue.AsProtobufJSON | null;
    operatingSchedule: googleProtobuf001.StringValue.AsProtobufJSON | null;
    pointOfInterestLocations: Location.AsProtobufJSON[] | null;
    durationFromMinutes: googleProtobuf001.Int32Value.AsProtobufJSON | null;
    durationToMinutes: googleProtobuf001.Int32Value.AsProtobufJSON | null;
    stopLocations: Location.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.GetTopCategoryByLocationRequest
 */
export class GetTopCategoryByLocationRequest implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.GetTopCategoryByLocationRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetTopCategoryByLocationRequest();
    GetTopCategoryByLocationRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetTopCategoryByLocationRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.languageCode = _instance.languageCode || '';
    _instance.locationId = _instance.locationId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetTopCategoryByLocationRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.languageCode = _reader.readString();
          break;
        case 5:
          _instance.locationId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetTopCategoryByLocationRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetTopCategoryByLocationRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.languageCode) {
      _writer.writeString(4, _instance.languageCode);
    }
    if (_instance.locationId) {
      _writer.writeInt32(5, _instance.locationId);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _languageCode: string;
  private _locationId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetTopCategoryByLocationRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<GetTopCategoryByLocationRequest.AsObject>
  ) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.languageCode = _value.languageCode;
    this.locationId = _value.locationId;
    GetTopCategoryByLocationRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get locationId(): number {
    return this._locationId;
  }
  set locationId(value: number) {
    this._locationId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetTopCategoryByLocationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetTopCategoryByLocationRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      locationId: this.locationId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetTopCategoryByLocationRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      locationId: this.locationId
    };
  }
}
export module GetTopCategoryByLocationRequest {
  /**
   * Standard JavaScript object representation for GetTopCategoryByLocationRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    locationId: number;
  }

  /**
   * Protobuf JSON representation for GetTopCategoryByLocationRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    locationId: number;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.GetTopCategoryByLocationResponse
 */
export class GetTopCategoryByLocationResponse implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.GetTopCategoryByLocationResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetTopCategoryByLocationResponse();
    GetTopCategoryByLocationResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetTopCategoryByLocationResponse) {
    _instance.topCategories = _instance.topCategories || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetTopCategoryByLocationResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new TopCategoryItem();
          _reader.readMessage(
            messageInitializer1,
            TopCategoryItem.deserializeBinaryFromReader
          );
          (_instance.topCategories = _instance.topCategories || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetTopCategoryByLocationResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetTopCategoryByLocationResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.topCategories && _instance.topCategories.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.topCategories as any,
        TopCategoryItem.serializeBinaryToWriter
      );
    }
  }

  private _topCategories?: TopCategoryItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetTopCategoryByLocationResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<GetTopCategoryByLocationResponse.AsObject>
  ) {
    _value = _value || {};
    this.topCategories = (_value.topCategories || []).map(
      m => new TopCategoryItem(m)
    );
    GetTopCategoryByLocationResponse.refineValues(this);
  }
  get topCategories(): TopCategoryItem[] | undefined {
    return this._topCategories;
  }
  set topCategories(value: TopCategoryItem[] | undefined) {
    this._topCategories = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetTopCategoryByLocationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetTopCategoryByLocationResponse.AsObject {
    return {
      topCategories: (this.topCategories || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetTopCategoryByLocationResponse.AsProtobufJSON {
    return {
      topCategories: (this.topCategories || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module GetTopCategoryByLocationResponse {
  /**
   * Standard JavaScript object representation for GetTopCategoryByLocationResponse
   */
  export interface AsObject {
    topCategories?: TopCategoryItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetTopCategoryByLocationResponse
   */
  export interface AsProtobufJSON {
    topCategories: TopCategoryItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.TopCategoryItem
 */
export class TopCategoryItem implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.TopCategoryItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new TopCategoryItem();
    TopCategoryItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: TopCategoryItem) {
    _instance.attributeId = _instance.attributeId || 0;
    _instance.sortOrder = _instance.sortOrder || 0;
    _instance.attributeName = _instance.attributeName || '';
    _instance.imageUrl = _instance.imageUrl || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: TopCategoryItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.attributeId = _reader.readInt32();
          break;
        case 2:
          _instance.sortOrder = _reader.readInt32();
          break;
        case 3:
          _instance.attributeName = _reader.readString();
          break;
        case 4:
          _instance.imageUrl = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    TopCategoryItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: TopCategoryItem,
    _writer: BinaryWriter
  ) {
    if (_instance.attributeId) {
      _writer.writeInt32(1, _instance.attributeId);
    }
    if (_instance.sortOrder) {
      _writer.writeInt32(2, _instance.sortOrder);
    }
    if (_instance.attributeName) {
      _writer.writeString(3, _instance.attributeName);
    }
    if (_instance.imageUrl) {
      _writer.writeString(4, _instance.imageUrl);
    }
  }

  private _attributeId: number;
  private _sortOrder: number;
  private _attributeName: string;
  private _imageUrl: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of TopCategoryItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<TopCategoryItem.AsObject>) {
    _value = _value || {};
    this.attributeId = _value.attributeId;
    this.sortOrder = _value.sortOrder;
    this.attributeName = _value.attributeName;
    this.imageUrl = _value.imageUrl;
    TopCategoryItem.refineValues(this);
  }
  get attributeId(): number {
    return this._attributeId;
  }
  set attributeId(value: number) {
    this._attributeId = value;
  }
  get sortOrder(): number {
    return this._sortOrder;
  }
  set sortOrder(value: number) {
    this._sortOrder = value;
  }
  get attributeName(): string {
    return this._attributeName;
  }
  set attributeName(value: string) {
    this._attributeName = value;
  }
  get imageUrl(): string {
    return this._imageUrl;
  }
  set imageUrl(value: string) {
    this._imageUrl = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    TopCategoryItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): TopCategoryItem.AsObject {
    return {
      attributeId: this.attributeId,
      sortOrder: this.sortOrder,
      attributeName: this.attributeName,
      imageUrl: this.imageUrl
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): TopCategoryItem.AsProtobufJSON {
    return {
      attributeId: this.attributeId,
      sortOrder: this.sortOrder,
      attributeName: this.attributeName,
      imageUrl: this.imageUrl
    };
  }
}
export module TopCategoryItem {
  /**
   * Standard JavaScript object representation for TopCategoryItem
   */
  export interface AsObject {
    attributeId: number;
    sortOrder: number;
    attributeName: string;
    imageUrl: string;
  }

  /**
   * Protobuf JSON representation for TopCategoryItem
   */
  export interface AsProtobufJSON {
    attributeId: number;
    sortOrder: number;
    attributeName: string;
    imageUrl: string;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.ProductAvailabilityRangesRequest
 */
export class ProductAvailabilityRangesRequest implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.ProductAvailabilityRangesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ProductAvailabilityRangesRequest();
    ProductAvailabilityRangesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ProductAvailabilityRangesRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.productId = _instance.productId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ProductAvailabilityRangesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.productId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    ProductAvailabilityRangesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ProductAvailabilityRangesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.productId) {
      _writer.writeInt32(4, _instance.productId);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _productId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ProductAvailabilityRangesRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<ProductAvailabilityRangesRequest.AsObject>
  ) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.productId = _value.productId;
    ProductAvailabilityRangesRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get productId(): number {
    return this._productId;
  }
  set productId(value: number) {
    this._productId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ProductAvailabilityRangesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ProductAvailabilityRangesRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      productId: this.productId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ProductAvailabilityRangesRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      productId: this.productId
    };
  }
}
export module ProductAvailabilityRangesRequest {
  /**
   * Standard JavaScript object representation for ProductAvailabilityRangesRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    productId: number;
  }

  /**
   * Protobuf JSON representation for ProductAvailabilityRangesRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    productId: number;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.ProductAvailabilityRangesResponse
 */
export class ProductAvailabilityRangesResponse implements GrpcMessage {
  static id =
    'booking_platform.v1.attraction.ProductAvailabilityRangesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ProductAvailabilityRangesResponse();
    ProductAvailabilityRangesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ProductAvailabilityRangesResponse) {
    _instance.availableRanges = _instance.availableRanges || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ProductAvailabilityRangesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new booking_platformV1Shared006.ProductAvailabilityRange();
          _reader.readMessage(
            messageInitializer1,
            booking_platformV1Shared006.ProductAvailabilityRange
              .deserializeBinaryFromReader
          );
          (_instance.availableRanges = _instance.availableRanges || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ProductAvailabilityRangesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ProductAvailabilityRangesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.availableRanges && _instance.availableRanges.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.availableRanges as any,
        booking_platformV1Shared006.ProductAvailabilityRange
          .serializeBinaryToWriter
      );
    }
  }

  private _availableRanges?: booking_platformV1Shared006.ProductAvailabilityRange[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ProductAvailabilityRangesResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<ProductAvailabilityRangesResponse.AsObject>
  ) {
    _value = _value || {};
    this.availableRanges = (_value.availableRanges || []).map(
      m => new booking_platformV1Shared006.ProductAvailabilityRange(m)
    );
    ProductAvailabilityRangesResponse.refineValues(this);
  }
  get availableRanges():
    | booking_platformV1Shared006.ProductAvailabilityRange[]
    | undefined {
    return this._availableRanges;
  }
  set availableRanges(
    value: booking_platformV1Shared006.ProductAvailabilityRange[] | undefined
  ) {
    this._availableRanges = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ProductAvailabilityRangesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ProductAvailabilityRangesResponse.AsObject {
    return {
      availableRanges: (this.availableRanges || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ProductAvailabilityRangesResponse.AsProtobufJSON {
    return {
      availableRanges: (this.availableRanges || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module ProductAvailabilityRangesResponse {
  /**
   * Standard JavaScript object representation for ProductAvailabilityRangesResponse
   */
  export interface AsObject {
    availableRanges?: booking_platformV1Shared006.ProductAvailabilityRange.AsObject[];
  }

  /**
   * Protobuf JSON representation for ProductAvailabilityRangesResponse
   */
  export interface AsProtobufJSON {
    availableRanges:
      | booking_platformV1Shared006.ProductAvailabilityRange.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AttractionInfoRequest
 */
export class AttractionInfoRequest implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AttractionInfoRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttractionInfoRequest();
    AttractionInfoRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttractionInfoRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.languageCode = _instance.languageCode || '';
    _instance.productIds = _instance.productIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttractionInfoRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.languageCode = _reader.readString();
          break;
        case 5:
          (_instance.productIds = _instance.productIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AttractionInfoRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttractionInfoRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.languageCode) {
      _writer.writeString(4, _instance.languageCode);
    }
    if (_instance.productIds && _instance.productIds.length) {
      _writer.writePackedInt32(5, _instance.productIds);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _languageCode: string;
  private _productIds: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttractionInfoRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttractionInfoRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.languageCode = _value.languageCode;
    this.productIds = (_value.productIds || []).slice();
    AttractionInfoRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get productIds(): number[] {
    return this._productIds;
  }
  set productIds(value: number[]) {
    this._productIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttractionInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttractionInfoRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      productIds: (this.productIds || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttractionInfoRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      productIds: (this.productIds || []).slice()
    };
  }
}
export module AttractionInfoRequest {
  /**
   * Standard JavaScript object representation for AttractionInfoRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    productIds: number[];
  }

  /**
   * Protobuf JSON representation for AttractionInfoRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    productIds: number[];
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AttractionInfoResponse
 */
export class AttractionInfoResponse implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AttractionInfoResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttractionInfoResponse();
    AttractionInfoResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttractionInfoResponse) {
    _instance.attractionInfoResponseItems =
      _instance.attractionInfoResponseItems || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttractionInfoResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AttractionInfoResponseItem();
          _reader.readMessage(
            messageInitializer1,
            AttractionInfoResponseItem.deserializeBinaryFromReader
          );
          (_instance.attractionInfoResponseItems =
            _instance.attractionInfoResponseItems || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AttractionInfoResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttractionInfoResponse,
    _writer: BinaryWriter
  ) {
    if (
      _instance.attractionInfoResponseItems &&
      _instance.attractionInfoResponseItems.length
    ) {
      _writer.writeRepeatedMessage(
        1,
        _instance.attractionInfoResponseItems as any,
        AttractionInfoResponseItem.serializeBinaryToWriter
      );
    }
  }

  private _attractionInfoResponseItems?: AttractionInfoResponseItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttractionInfoResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttractionInfoResponse.AsObject>) {
    _value = _value || {};
    this.attractionInfoResponseItems = (
      _value.attractionInfoResponseItems || []
    ).map(m => new AttractionInfoResponseItem(m));
    AttractionInfoResponse.refineValues(this);
  }
  get attractionInfoResponseItems(): AttractionInfoResponseItem[] | undefined {
    return this._attractionInfoResponseItems;
  }
  set attractionInfoResponseItems(
    value: AttractionInfoResponseItem[] | undefined
  ) {
    this._attractionInfoResponseItems = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttractionInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttractionInfoResponse.AsObject {
    return {
      attractionInfoResponseItems: (
        this.attractionInfoResponseItems || []
      ).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttractionInfoResponse.AsProtobufJSON {
    return {
      attractionInfoResponseItems: (
        this.attractionInfoResponseItems || []
      ).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AttractionInfoResponse {
  /**
   * Standard JavaScript object representation for AttractionInfoResponse
   */
  export interface AsObject {
    attractionInfoResponseItems?: AttractionInfoResponseItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for AttractionInfoResponse
   */
  export interface AsProtobufJSON {
    attractionInfoResponseItems:
      | AttractionInfoResponseItem.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.attraction.AttractionInfoResponseItem
 */
export class AttractionInfoResponseItem implements GrpcMessage {
  static id = 'booking_platform.v1.attraction.AttractionInfoResponseItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttractionInfoResponseItem();
    AttractionInfoResponseItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttractionInfoResponseItem) {
    _instance.productId = _instance.productId || 0;
    _instance.productName = _instance.productName || '';
    _instance.locationName = _instance.locationName || undefined;
    _instance.mainImageUrl = _instance.mainImageUrl || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttractionInfoResponseItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.productId = _reader.readInt32();
          break;
        case 2:
          _instance.productName = _reader.readString();
          break;
        case 3:
          _instance.locationName = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.locationName,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.mainImageUrl = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.mainImageUrl,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AttractionInfoResponseItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttractionInfoResponseItem,
    _writer: BinaryWriter
  ) {
    if (_instance.productId) {
      _writer.writeInt32(1, _instance.productId);
    }
    if (_instance.productName) {
      _writer.writeString(2, _instance.productName);
    }
    if (_instance.locationName) {
      _writer.writeMessage(
        3,
        _instance.locationName as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.mainImageUrl) {
      _writer.writeMessage(
        4,
        _instance.mainImageUrl as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _productId: number;
  private _productName: string;
  private _locationName?: googleProtobuf001.StringValue;
  private _mainImageUrl?: googleProtobuf001.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttractionInfoResponseItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttractionInfoResponseItem.AsObject>) {
    _value = _value || {};
    this.productId = _value.productId;
    this.productName = _value.productName;
    this.locationName = _value.locationName
      ? new googleProtobuf001.StringValue(_value.locationName)
      : undefined;
    this.mainImageUrl = _value.mainImageUrl
      ? new googleProtobuf001.StringValue(_value.mainImageUrl)
      : undefined;
    AttractionInfoResponseItem.refineValues(this);
  }
  get productId(): number {
    return this._productId;
  }
  set productId(value: number) {
    this._productId = value;
  }
  get productName(): string {
    return this._productName;
  }
  set productName(value: string) {
    this._productName = value;
  }
  get locationName(): googleProtobuf001.StringValue | undefined {
    return this._locationName;
  }
  set locationName(value: googleProtobuf001.StringValue | undefined) {
    this._locationName = value;
  }
  get mainImageUrl(): googleProtobuf001.StringValue | undefined {
    return this._mainImageUrl;
  }
  set mainImageUrl(value: googleProtobuf001.StringValue | undefined) {
    this._mainImageUrl = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttractionInfoResponseItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttractionInfoResponseItem.AsObject {
    return {
      productId: this.productId,
      productName: this.productName,
      locationName: this.locationName
        ? this.locationName.toObject()
        : undefined,
      mainImageUrl: this.mainImageUrl ? this.mainImageUrl.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttractionInfoResponseItem.AsProtobufJSON {
    return {
      productId: this.productId,
      productName: this.productName,
      locationName: this.locationName
        ? this.locationName.toProtobufJSON(options)
        : null,
      mainImageUrl: this.mainImageUrl
        ? this.mainImageUrl.toProtobufJSON(options)
        : null
    };
  }
}
export module AttractionInfoResponseItem {
  /**
   * Standard JavaScript object representation for AttractionInfoResponseItem
   */
  export interface AsObject {
    productId: number;
    productName: string;
    locationName?: googleProtobuf001.StringValue.AsObject;
    mainImageUrl?: googleProtobuf001.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for AttractionInfoResponseItem
   */
  export interface AsProtobufJSON {
    productId: number;
    productName: string;
    locationName: googleProtobuf001.StringValue.AsProtobufJSON | null;
    mainImageUrl: googleProtobuf001.StringValue.AsProtobufJSON | null;
  }
}
